(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["barra-superior"] && !Shopify.designMode) return;
  try {
    
(function () {
  var bar = document.querySelector('[data-barsup-uc]');
  if (!bar) return;

  var track = bar.querySelector('.barsup-uc__track');
  if (track) {
    var base = track.querySelector('.barsup-uc__grupo');
    var rellenando = false;

    function medir() {
      return base ? base.getBoundingClientRect().width : 0;
    }

    function rellenar() {
      if (!base || rellenando) return;
      rellenando = true;
      var w = medir();
      if (w > 0) {
        var vw = window.innerWidth || document.documentElement.clientWidth;
        var necesarios = Math.ceil((vw + w) / w) + 1;
        if (necesarios < 2) necesarios = 2;
        var actuales = track.querySelectorAll('.barsup-uc__grupo').length;
        while (actuales < necesarios) {
          var copia = base.cloneNode(true);
          copia.setAttribute('aria-hidden', 'true');
          track.appendChild(copia);
          actuales++;
        }
        track.style.setProperty('--bs-shift', w + 'px', 'important');
      }
      rellenando = false;
    }

    rellenar();
    window.addEventListener('load', rellenar);
    window.addEventListener('resize', rellenar);
    setTimeout(rellenar, 300);
    setTimeout(rellenar, 900);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(rellenar);
    }
  }

  if (bar.getAttribute('data-fijar') !== '1') return;

  var wrap = bar.closest('.shopify-section') || bar;
  var espaciador = wrap.nextElementSibling;
  if (!espaciador || !espaciador.classList.contains('barsup-uc-espaciador')) {
    espaciador = document.createElement('div');
    espaciador.className = 'barsup-uc-espaciador';
    wrap.parentNode.insertBefore(espaciador, wrap.nextSibling);
  }

  function aplicar() {
    var h = bar.offsetHeight;
    espaciador.style.height = h + 'px';
    document.documentElement.style.setProperty('--barsup-uc-alto', h + 'px');
    var cabFija = document.querySelector('.cabecera-uc-fija');
    if (cabFija) {
      cabFija.style.setProperty('top', h + 'px', 'important');
    }
  }

  aplicar();
  window.addEventListener('resize', aplicar);
  window.addEventListener('load', aplicar);
  setTimeout(aplicar, 350);
  setTimeout(aplicar, 800);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["beneficios"] && !Shopify.designMode) return;
  try {
    
(function () {
  var raiz = document.querySelector('[data-benef-uc]');
  if (!raiz) return;
  if (!raiz.classList.contains('benef-uc--animar')) return;
  if (!('IntersectionObserver' in window)) { raiz.classList.add('benef-uc--visible'); return; }
  var obs = new IntersectionObserver(function (entradas) {
    entradas.forEach(function (e) {
      if (e.isIntersecting) { raiz.classList.add('benef-uc--visible'); obs.disconnect(); }
    });
  }, { threshold: 0.15 });
  obs.observe(raiz);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["busqueda"] && !Shopify.designMode) return;
  try {
    
(function () {
  var raiz = document.querySelector('[data-buscar-uc]');
  if (!raiz) return;

  var input = raiz.querySelector('[data-buscar-input]');
  var vistaDef = raiz.querySelector('[data-buscar-defecto]');
  var vistaRes = raiz.querySelector('[data-buscar-resultados]');
  var lista = raiz.querySelector('[data-buscar-lista]');
  var estado = raiz.querySelector('[data-buscar-estado]');
  var verTodos = raiz.querySelector('[data-buscar-vertodos]');
  var cierres = raiz.querySelectorAll('[data-buscar-cerrar]');
  var base = raiz.getAttribute('data-base') || '/search';
  var sugUrl = raiz.getAttribute('data-sugerir');
  var extra = (raiz.getAttribute('data-selector') || '').trim();
  var sinTxt = raiz.getAttribute('data-sin') || '';
  var form = raiz.querySelector('[data-buscar-form]');
  var bloqueRec = raiz.querySelector('[data-buscar-recientes]');
  var chipsRec = raiz.querySelector('[data-buscar-recientes-chips]');
  var btnBorrar = raiz.querySelector('[data-buscar-borrar]');
  var maxRec = parseInt(raiz.getAttribute('data-max-recientes') || '6', 10);
  var CLAVE_REC = 'buscar_uc_recientes_v1';

  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function leerRecientes() { try { var a = JSON.parse(localStorage.getItem(CLAVE_REC) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
  function guardar(q) {
    q = (q || '').trim();
    if (q.length < 2) return;
    var arr = leerRecientes().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
    arr.unshift(q);
    arr = arr.slice(0, maxRec > 0 ? maxRec : 6);
    try { localStorage.setItem(CLAVE_REC, JSON.stringify(arr)); } catch (e) {}
  }
  function pintarRecientes() {
    if (!bloqueRec || !chipsRec) return;
    var arr = leerRecientes();
    if (!arr.length) { bloqueRec.hidden = true; chipsRec.innerHTML = ''; return; }
    chipsRec.innerHTML = arr.map(function (q) {
      var e = esc(q);
      return '<button type="button" class="buscar-uc__chip" data-reciente="' + e + '">' + e + '</button>';
    }).join('');
    bloqueRec.hidden = false;
  }

  function abrir() {
    raiz.classList.add('uc-activo');
    document.body.style.overflow = 'hidden';
    pintarRecientes();
    setTimeout(function () { if (input) input.focus(); }, 140);
  }
  function cerrar() {
    raiz.classList.remove('uc-activo');
    document.body.style.overflow = '';
  }

  var selectores = '[data-abrir-buscar]';
  if (extra) selectores += ', ' + extra;

  document.addEventListener('click', function (e) {
    var t = e.target.closest(selectores);
    if (t) { e.preventDefault(); abrir(); return; }
    var a = e.target.closest('a[href]');
    if (a) {
      try {
        var u = new URL(a.href, window.location.origin);
        if (/\/search\/?$/.test(u.pathname) && !u.search) { e.preventDefault(); abrir(); }
      } catch (err) {}
    }
  });

  cierres.forEach(function (b) { b.addEventListener('click', cerrar); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') cerrar(); });

  function tarjeta(p) {
    var url = p.url || '#';
    var img = p.image || (p.featured_image && p.featured_image.url) || '';
    var imgHtml = img ? '<img src="' + img + '" alt="" loading="lazy">' : '';
    var marca = p.vendor ? '<span class="buscar-uc__res-marca">' + p.vendor + '</span>' : '';
    return '<a class="buscar-uc__res" href="' + url + '"><span class="buscar-uc__res-img">' + imgHtml + '</span><span class="buscar-uc__res-info"><span class="buscar-uc__res-titulo">' + (p.title || '') + '</span>' + marca + '</span></a>';
  }

  var temporizador;
  function buscar(q) {
    if (!sugUrl) return;
    var url = sugUrl + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last';
    fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var prods = (d && d.resources && d.resources.results && d.resources.results.products) || [];
        if (verTodos) verTodos.href = base + '?q=' + encodeURIComponent(q);
        if (!prods.length) {
          lista.innerHTML = '';
          estado.textContent = sinTxt;
          estado.hidden = false;
          return;
        }
        estado.hidden = true;
        lista.innerHTML = prods.map(tarjeta).join('');
      })
      .catch(function () {});
  }

  if (input) {
    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(temporizador);
      if (q.length < 2) {
        vistaRes.hidden = true;
        vistaDef.hidden = false;
        return;
      }
      vistaDef.hidden = true;
      vistaRes.hidden = false;
      estado.hidden = true;
      temporizador = setTimeout(function () { buscar(q); }, 220);
    });
  }

  if (form) { form.addEventListener('submit', function () { guardar(input ? input.value : ''); }); }
  if (verTodos) { verTodos.addEventListener('click', function () { guardar(input ? input.value : ''); }); }
  if (lista) { lista.addEventListener('click', function (e) { if (e.target.closest('a')) guardar(input ? input.value : ''); }); }
  if (vistaDef) {
    vistaDef.addEventListener('click', function (e) {
      var a = e.target.closest('a.buscar-uc__chip');
      if (a) guardar(a.textContent);
    });
  }
  if (chipsRec) {
    chipsRec.addEventListener('click', function (e) {
      var b = e.target.closest('[data-reciente]');
      if (!b) return;
      var q = b.getAttribute('data-reciente');
      guardar(q);
      if (input) {
        input.value = q;
        input.focus();
        input.dispatchEvent(new Event('input', { bubbles: true }));
      }
    });
  }
  if (btnBorrar) {
    btnBorrar.addEventListener('click', function () {
      try { localStorage.removeItem(CLAVE_REC); } catch (e) {}
      pintarRecientes();
    });
  }

  pintarRecientes();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cabecera-uc"] && !Shopify.designMode) return;
  try {
    
(function () {
  var raiz = document.querySelector('[data-ucnav]');
  if (!raiz) return;

  var abrir = raiz.querySelector('[data-ucnav-abrir]');
  var cerrar = raiz.querySelector('[data-ucnav-cerrar]');
  var overlay = raiz.querySelector('[data-ucnav-overlay]');
  var drawer = raiz.querySelector('[data-ucnav-drawer]');

  function abrirMenu() {
    if (!drawer) return;
    drawer.classList.add('ucnav-activo');
    if (overlay) overlay.classList.add('ucnav-activo');
    drawer.setAttribute('aria-hidden', 'false');
    if (abrir) abrir.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function cerrarMenu() {
    if (!drawer) return;
    drawer.classList.remove('ucnav-activo');
    if (overlay) overlay.classList.remove('ucnav-activo');
    drawer.setAttribute('aria-hidden', 'true');
    if (abrir) abrir.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }
  if (abrir) abrir.addEventListener('click', abrirMenu);
  if (cerrar) cerrar.addEventListener('click', cerrarMenu);
  if (overlay) overlay.addEventListener('click', cerrarMenu);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') cerrarMenu();
  });

  var fijoActivo = raiz.getAttribute('data-fijo') === '1';
  if (fijoActivo) {
    var barra = raiz.querySelector('[data-ucnav-barra]');
    if (barra) {
      var espaciador = document.createElement('div');
      espaciador.className = 'ucnav__espaciador';
      barra.parentNode.insertBefore(espaciador, barra.nextSibling);

      var fijo = false;

      function puntoDisparo() {
        var rectRef = fijo ? espaciador.getBoundingClientRect() : barra.getBoundingClientRect();
        return rectRef.top + window.scrollY;
      }

      function fijar() {
        if (fijo) return;
        fijo = true;
        espaciador.style.height = barra.offsetHeight + 'px';
        document.body.appendChild(barra);
        barra.classList.add('ucnav__barra--fijo');
      }
      function soltar() {
        if (!fijo) return;
        fijo = false;
        raiz.insertBefore(barra, espaciador);
        barra.classList.remove('ucnav__barra--fijo');
        espaciador.style.height = '0px';
      }

      function evaluar() {
        if (window.scrollY > puntoDisparo()) fijar();
        else soltar();
      }

      var ticking = false;
      window.addEventListener('scroll', function () {
        if (!ticking) {
          window.requestAnimationFrame(function () { evaluar(); ticking = false; });
          ticking = true;
        }
      }, { passive: true });
      window.addEventListener('resize', evaluar);
      window.addEventListener('load', evaluar);
      evaluar();
    }
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carrito-lateral-uc"] && !Shopify.designMode) return;
  try {
    
(function () {
  var raiz = document.querySelector('[data-carrito-uc]');
  if (!raiz) return;

  var formato = raiz.getAttribute('data-money-format') || '${{amount}}';
  var recientesLimite = parseInt(raiz.getAttribute('data-recientes-limite'), 10) || 6;
  var abrirHover = raiz.getAttribute('data-abrir-hover') === '1';
  var CLAVE = 'uc_recientes';

  var panel = raiz.querySelector('.carrito-uc__panel');
  var contador = raiz.querySelector('[data-uc-contador]');
  var items = raiz.querySelector('[data-uc-items]');
  var vacio = raiz.querySelector('[data-uc-vacio]');
  var pie = raiz.querySelector('[data-uc-pie]');
  var subtotal = raiz.querySelector('[data-uc-subtotal]');
  var recientesCaja = raiz.querySelector('[data-uc-recientes]');
  var recientesPista = raiz.querySelector('[data-uc-recientes-pista]');
  var ultimoCarrito = null;

  function esc(t) {
    return String(t == null ? '' : t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function conAncho(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function dinero(centavos) {
    var num = Number(centavos);
    function sep(n, p, miles, dec) {
      p = p == null ? 2 : p; miles = miles || ','; dec = dec || '.';
      if (isNaN(n)) return '0';
      n = (n / 100).toFixed(p);
      var partes = n.split('.');
      var ent = partes[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + miles);
      return ent + (partes[1] ? dec + partes[1] : '');
    }
    var ph = /\{\{\s*(\w+)\s*\}\}/;
    var m = formato.match(ph);
    if (!m) return formato;
    var val;
    switch (m[1]) {
      case 'amount': val = sep(num, 2); break;
      case 'amount_no_decimals': val = sep(num, 0); break;
      case 'amount_with_comma_separator': val = sep(num, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': val = sep(num, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': val = sep(num, 2, "'", '.'); break;
      case 'amount_with_space_separator': val = sep(num, 2, ' ', '.'); break;
      case 'amount_no_decimals_with_space_separator': val = sep(num, 0, ' ', '.'); break;
      default: val = sep(num, 2);
    }
    return formato.replace(ph, val);
  }

  function abrir() { raiz.classList.add('uc-abierto'); document.body.style.overflow = 'hidden'; }
  function cerrar() { raiz.classList.remove('uc-abierto'); document.body.style.overflow = ''; }

  function destinoCarrito() {
    return document.querySelector('.cabecera-uc__icono-btn--carrito') ||
           document.querySelector('[data-uc-abrir]') ||
           document.querySelector('a[href$="/cart"]');
  }

  function imagenDeForm(form) {
    var cont = form.closest('[class*="product"], article, .card, .grid__item, li');
    var img = cont ? cont.querySelector('img') : null;
    if (img) return img;
    return document.querySelector('[data-prod-principal], .product__media img, [class*="product"] img');
  }

  function volarAlCarrito(img) {
    return new Promise(function (resolve) {
      var destino = destinoCarrito();
      if (!img || !destino) { resolve(); return; }
      var o = img.getBoundingClientRect();
      var d = destino.getBoundingClientRect();
      if (o.width === 0 || o.height === 0) { resolve(); return; }
      var clon = document.createElement('img');
      clon.src = img.currentSrc || img.src;
      clon.style.cssText = 'position:fixed;z-index:10200;left:' + o.left + 'px;top:' + o.top + 'px;width:' + o.width + 'px;height:' + o.height + 'px;object-fit:cover;border-radius:12px;pointer-events:none;box-shadow:0 12px 30px rgba(0,0,0,0.25);transition:transform 0.72s cubic-bezier(0.5,-0.2,0.4,1),opacity 0.72s ease;opacity:0.96;';
      document.body.appendChild(clon);
      var dx = (d.left + d.width / 2) - (o.left + o.width / 2);
      var dy = (d.top + d.height / 2) - (o.top + o.height / 2);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          clon.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(0.12)';
          clon.style.opacity = '0.2';
        });
      });
      setTimeout(function () {
        destino.style.transition = 'transform 0.2s ease';
        destino.style.transform = 'scale(1.28)';
        setTimeout(function () { destino.style.transform = ''; }, 220);
      }, 660);
      setTimeout(function () {
        if (clon.parentNode) clon.parentNode.removeChild(clon);
        resolve();
      }, 740);
    });
  }

  function vistaItem(item) {
    var variante = (item.variant_title && item.variant_title !== '') ? '<span class="carrito-uc__item-var">' + esc(item.variant_title) + '</span>' : '';
    var img = item.image ? '<img src="' + conAncho(item.image, 160) + '" alt="">' : '';
    return '<li class="carrito-uc__item" data-uc-key="' + item.key + '">' +
      '<a class="carrito-uc__item-img" href="' + item.url + '">' + img + '</a>' +
      '<div class="carrito-uc__item-info">' +
        '<a class="carrito-uc__item-titulo" href="' + item.url + '">' + esc(item.product_title) + '</a>' +
        variante +
        '<div class="carrito-uc__item-fila">' +
          '<div class="carrito-uc__stepper">' +
            '<button type="button" data-uc-key="' + item.key + '" data-uc-accion="menos" aria-label="Quitar uno"><svg class="carrito-uc__ico"><use href="#cuico-menos"></use></svg></button>' +
            '<span>' + item.quantity + '</span>' +
            '<button type="button" data-uc-key="' + item.key + '" data-uc-accion="mas" aria-label="A√±adir uno"><svg class="carrito-uc__ico"><use href="#cuico-mas"></use></svg></button>' +
          '</div>' +
          '<span class="carrito-uc__item-precio">' + dinero(item.final_line_price) + '</span>' +
        '</div>' +
      '</div>' +
      '<button type="button" class="carrito-uc__item-quitar" data-uc-key="' + item.key + '" data-uc-accion="quitar" aria-label="Eliminar"><svg class="carrito-uc__ico"><use href="#cuico-basura"></use></svg></button>' +
    '</li>';
  }

  function pintar(cart) {
    ultimoCarrito = cart;
    if (contador) contador.textContent = cart.item_count;
    if (cart.item_count === 0) {
      if (items) items.innerHTML = '';
      if (vacio) vacio.hidden = false;
      if (pie) pie.hidden = true;
    } else {
      if (vacio) vacio.hidden = true;
      if (pie) pie.hidden = false;
      if (items) items.innerHTML = cart.items.map(vistaItem).join('');
      if (subtotal) subtotal.textContent = dinero(cart.items_subtotal_price || cart.total_price);
    }
    pintarRecientes();
    refrescarFlechas();
    if (cuponActivo) mostrarResumen(cart);
  }

  function obtenerCarrito() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { pintar(cart); return cart; });
  }

  function cambiar(key, cantidad) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: cantidad })
    }).then(function (r) { return r.json(); }).then(function (cart) { pintar(cart); return cart; });
  }

  function agregar(id, cantidad) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: cantidad || 1 })
    }).then(function (r) { return r.json(); }).then(function () { return obtenerCarrito(); });
  }

  function leerRecientes() {
    try { return JSON.parse(window.localStorage.getItem(CLAVE)) || []; } catch (e) { return []; }
  }
  function guardarReciente(p) {
    try {
      var lista = leerRecientes().filter(function (x) { return x.handle !== p.handle; });
      lista.unshift(p);
      lista = lista.slice(0, 12);
      window.localStorage.setItem(CLAVE, JSON.stringify(lista));
    } catch (e) {}
  }

  function vistaSugerido(p) {
    var img = p.image ? '<img src="' + conAncho(p.image, 200) + '" alt="">' : '';
    var accion;
    if (p.multi !== false) {
      accion = '<a class="carrito-uc__sug-add carrito-uc__sug-add--link" href="' + p.url + '"><span>' + esc(raiz.getAttribute('data-elegir-texto') || 'Elegir talla') + '</span></a>';
    } else if (p.available) {
      accion = '<button type="button" class="carrito-uc__sug-add" data-uc-quickadd data-uc-vid="' + p.vid + '"><svg class="carrito-uc__ico"><use href="#cuico-mas"></use></svg><span>' + esc(raiz.getAttribute('data-add-texto') || 'A√±adir') + '</span></button>';
    } else {
      accion = '<button type="button" class="carrito-uc__sug-add carrito-uc__sug-add--off" disabled>Agotado</button>';
    }
    return '<article class="carrito-uc__sug-card">' +
      '<a class="carrito-uc__sug-img" href="' + p.url + '">' + img + '</a>' +
      '<a class="carrito-uc__sug-nombre" href="' + p.url + '">' + esc(p.title) + '</a>' +
      '<span class="carrito-uc__sug-precio">' + dinero(p.price) + '</span>' + accion +
    '</article>';
  }

  function pintarRecientes() {
    if (!recientesCaja || !recientesPista) return;
    var actual = handleActual();
    var lista = leerRecientes().filter(function (p) { return p.handle !== actual; }).slice(0, recientesLimite);
    if (lista.length === 0) {
      recientesCaja.hidden = true;
      return;
    }
    recientesPista.innerHTML = lista.map(vistaSugerido).join('');
    recientesCaja.hidden = false;
  }

  function handleActual() {
    var m = window.location.pathname.match(/\/products\/([^\/\?#]+)/);
    return m ? m[1] : null;
  }

  function registrarVista() {
    var handle = handleActual();
    if (!handle) return;
    fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var disp = (p.variants || []).filter(function (v) { return v.available; });
        var elegida = disp[0] || p.variants[0] || {};
        guardarReciente({
          handle: p.handle,
          title: p.title,
          url: '/products/' + p.handle,
          image: p.featured_image || (p.images && p.images[0]) || '',
          price: p.price,
          vid: elegida.id,
          available: disp.length > 0,
          multi: (p.variants || []).length > 1
        });
        pintarRecientes();
      }).catch(function () {});
  }

  function esDisparador(el) {
    if (!el || !el.closest) return null;
    return el.closest('.cabecera-uc__icono-btn--carrito, [data-uc-abrir], a[href$="/cart"], a[href*="/cart?"], a[href$="/cart/"]');
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented) return;
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var disp = esDisparador(e.target);
    if (disp && !disp.closest('[data-carrito-uc]')) {
      e.preventDefault();
      e.stopPropagation();
      obtenerCarrito().then(abrir);
      return;
    }
    if (e.target.closest('[data-uc-cerrar]')) { cerrar(); return; }
  }, true);

  if (abrirHover) {
    var bloqueoHover = false;
    document.addEventListener('mouseover', function (e) {
      if (!window.matchMedia('(min-width: 990px)').matches) return;
      var disp = esDisparador(e.target);
      if (!disp || disp.closest('[data-carrito-uc]')) return;
      if (bloqueoHover || raiz.classList.contains('uc-abierto')) return;
      bloqueoHover = true;
      obtenerCarrito().then(abrir);
    });
    document.addEventListener('mouseout', function (e) {
      var disp = esDisparador(e.target);
      if (disp && (!e.relatedTarget || !esDisparador(e.relatedTarget))) bloqueoHover = false;
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.getAttribute) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    var datos = new FormData(form);
    var boton = form.querySelector('[type="submit"]');
    if (boton) boton.classList.add('uc-cargando');
    var origen = imagenDeForm(form);
    var animacion = volarAlCarrito(origen);
    var peticion = fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: datos })
      .then(function (r) { return r.json(); })
      .then(function () { return obtenerCarrito(); });
    Promise.all([animacion, peticion])
      .then(function () { abrir(); if (boton) boton.classList.remove('uc-cargando'); })
      .catch(function () { if (boton) boton.classList.remove('uc-cargando'); });
  }, true);

  raiz.addEventListener('click', function (e) {
    var accionBtn = e.target.closest('[data-uc-accion]');
    if (accionBtn) {
      var key = accionBtn.getAttribute('data-uc-key');
      var li = accionBtn.closest('.carrito-uc__item');
      var actual = li ? parseInt(li.querySelector('.carrito-uc__stepper span').textContent, 10) : 1;
      var accion = accionBtn.getAttribute('data-uc-accion');
      if (accion === 'mas') cambiar(key, actual + 1);
      else if (accion === 'menos') cambiar(key, Math.max(0, actual - 1));
      else if (accion === 'quitar') cambiar(key, 0);
      return;
    }
    var quick = e.target.closest('[data-uc-quickadd]');
    if (quick) {
      var vid = quick.getAttribute('data-uc-vid');
      if (!vid) return;
      quick.classList.add('uc-cargando');
      agregar(vid, 1).then(function () { quick.classList.remove('uc-cargando'); }).catch(function () { quick.classList.remove('uc-cargando'); });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && raiz.classList.contains('uc-abierto')) cerrar();
  });
  window.addEventListener('pageshow', function () { obtenerCarrito(); });

  function activarFlechas(sug) {
    var pista = sug.querySelector('.carrito-uc__sug-pista');
    var prev = sug.querySelector('[data-sug-prev]');
    var next = sug.querySelector('[data-sug-next]');
    if (!pista) return;
    function paso() {
      var card = pista.querySelector('.carrito-uc__sug-card');
      return card ? (card.offsetWidth + 12) * 2 : 220;
    }
    function estado() {
      var max = pista.scrollWidth - pista.clientWidth;
      var sinScroll = max <= 4;
      if (prev) { prev.disabled = pista.scrollLeft <= 2; prev.style.display = sinScroll ? 'none' : ''; }
      if (next) { next.disabled = pista.scrollLeft >= max - 2; next.style.display = sinScroll ? 'none' : ''; }
    }
    if (!sug.getAttribute('data-flechas-listo')) {
      sug.setAttribute('data-flechas-listo', '1');
      if (prev) prev.addEventListener('click', function () { pista.scrollBy({ left: -paso(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { pista.scrollBy({ left: paso(), behavior: 'smooth' }); });
      pista.addEventListener('scroll', function () { window.requestAnimationFrame(estado); });
    }
    estado();
  }
  function refrescarFlechas() {
    raiz.querySelectorAll('.carrito-uc__sug').forEach(activarFlechas);
  }

  var cupon = raiz.querySelector('[data-uc-cupon]');
  var cuponActivo = '';
  var pagar = raiz.querySelector('[data-uc-pagar]');

  function actualizarPagar() {
    if (!pagar) return;
    pagar.href = cuponActivo ? ('/discount/' + encodeURIComponent(cuponActivo) + '?redirect=/checkout') : '/checkout';
  }

  function mostrarResumen(cart) {
    if (!cupon) return;
    var resumen = cupon.querySelector('[data-uc-resumen]');
    if (!resumen) return;
    var desc = cart.total_discount || 0;
    if (cuponActivo && desc > 0) {
      cupon.querySelector('[data-uc-r-sub]').textContent = dinero(cart.items_subtotal_price || cart.total_price + desc);
      cupon.querySelector('[data-uc-r-desc]').textContent = '- ' + dinero(desc);
      cupon.querySelector('[data-uc-r-total]').textContent = dinero(cart.total_price);
      resumen.hidden = false;
    } else {
      resumen.hidden = true;
    }
  }

  if (cupon) {
    var toggle = cupon.querySelector('[data-uc-cupon-toggle]');
    var panel = cupon.querySelector('[data-uc-cupon-panel]');
    var input = cupon.querySelector('[data-uc-cupon-input]');
    var aplicarBtn = cupon.querySelector('[data-uc-cupon-aplicar]');
    var msg = cupon.querySelector('[data-uc-cupon-msg]');
    var chip = cupon.querySelector('[data-uc-cupon-chip]');
    var chipCodigo = cupon.querySelector('[data-uc-cupon-codigo]');
    var quitarBtn = cupon.querySelector('[data-uc-cupon-quitar]');

    var T_OK = '{{ section.settings.cupon_ok }}';
    var T_INFO = '{{ section.settings.cupon_info }}';
    var T_ERROR = '{{ section.settings.cupon_error }}';

    function decirMsg(texto, tipo) {
      if (!msg) return;
      msg.textContent = texto;
      msg.className = 'carrito-uc__cupon-msg' + (tipo ? ' uc-' + tipo : '');
      msg.hidden = !texto;
    }

    if (toggle) toggle.addEventListener('click', function () {
      var abierto = cupon.classList.toggle('uc-cupon-abierto');
      if (panel) panel.hidden = !abierto;
      if (abierto && input) input.focus();
    });

    function aplicarCupon() {
      var codigo = (input ? input.value : '').trim();
      if (!codigo) { decirMsg(T_ERROR, 'error'); return; }
      if (aplicarBtn) aplicarBtn.classList.add('uc-cargando');
      decirMsg('', '');
      fetch('/discount/' + encodeURIComponent(codigo), { credentials: 'same-origin' })
        .then(function () { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          cuponActivo = codigo;
          actualizarPagar();
          if (chipCodigo) chipCodigo.textContent = codigo;
          if (chip) chip.hidden = false;
          if (cart.total_discount && cart.total_discount > 0) {
            decirMsg(T_OK, 'ok');
            mostrarResumen(cart);
          } else {
            decirMsg(T_INFO, 'info');
            mostrarResumen(cart);
          }
          pintar(cart);
          if (aplicarBtn) aplicarBtn.classList.remove('uc-cargando');
        })
        .catch(function () {
          if (aplicarBtn) aplicarBtn.classList.remove('uc-cargando');
          decirMsg(T_ERROR, 'error');
        });
    }

    if (aplicarBtn) aplicarBtn.addEventListener('click', aplicarCupon);
    if (input) input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); aplicarCupon(); }
    });

    if (quitarBtn) quitarBtn.addEventListener('click', function () {
      cuponActivo = '';
      actualizarPagar();
      if (chip) chip.hidden = true;
      if (input) input.value = '';
      decirMsg('', '');
      var resumen = cupon.querySelector('[data-uc-resumen]');
      if (resumen) resumen.hidden = true;
      fetch('/discount/clear', { credentials: 'same-origin' }).catch(function () {});
      obtenerCarrito();
    });
  }

  registrarVista();
  obtenerCarrito();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carrusel-producto"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciarCarrusel(raiz) {
    var pista = raiz.querySelector('[data-col-pista]');
    var thumb = raiz.querySelector('[data-col-thumb]');
    var prev = raiz.querySelector('[data-col-prev]');
    var next = raiz.querySelector('[data-col-next]');
    if (!pista) return;

    function maxScroll() {
      return pista.scrollWidth - pista.clientWidth;
    }

    function actualizar() {
      var ancho = pista.scrollWidth;
      if (ancho <= 0) return;
      var visible = (pista.clientWidth / ancho) * 100;
      if (visible > 100) visible = 100;
      if (visible < 8) visible = 8;
      var rango = 100 - visible;
      var fin = maxScroll();
      var avance = fin > 0 ? (pista.scrollLeft / fin) : 0;
      var pos = avance * rango;
      if (thumb) {
        thumb.style.setProperty('--cu-thumb-ancho', visible + '%');
        thumb.style.setProperty('--cu-thumb-left', pos + '%');
      }
      if (prev) prev.classList.toggle('col-inactiva', pista.scrollLeft <= 2);
      if (next) next.classList.toggle('col-inactiva', pista.scrollLeft >= fin - 2);
    }

    function desplazar(dir) {
      var card = pista.querySelector('.coleccion-uc__card');
      var paso = card ? (card.offsetWidth + 16) : pista.clientWidth * 0.8;
      var cantidad = Math.max(1, Math.floor(pista.clientWidth / paso)) * paso;
      pista.scrollBy({ left: dir * cantidad, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { desplazar(-1); });
    if (next) next.addEventListener('click', function () { desplazar(1); });

    pista.addEventListener('scroll', function () {
      window.requestAnimationFrame(actualizar);
    });
    window.addEventListener('resize', actualizar);
    window.addEventListener('load', actualizar);
    setTimeout(actualizar, 400);

    var progreso = raiz.querySelector('[data-col-progreso]');
    var scrubeando = false;

    function scrubA(clientX) {
      var r = progreso.getBoundingClientRect();
      if (r.width <= 0) return;
      var ratio = (clientX - r.left) / r.width;
      ratio = Math.max(0, Math.min(1, ratio));
      pista.scrollLeft = ratio * maxScroll();
      actualizar();
    }
    if (progreso) {
      progreso.addEventListener('pointerdown', function (e) {
        scrubeando = true;
        try { progreso.setPointerCapture(e.pointerId); } catch (err) {}
        scrubA(e.clientX);
      });
      progreso.addEventListener('pointermove', function (e) {
        if (scrubeando) scrubA(e.clientX);
      });
      progreso.addEventListener('pointerup', function () { scrubeando = false; });
      progreso.addEventListener('pointercancel', function () { scrubeando = false; });
    }

    var arrastrando = false;
    var inicioX = 0;
    var inicioScroll = 0;
    var movido = false;

    pista.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      arrastrando = true;
      movido = false;
      inicioX = e.clientX;
      inicioScroll = pista.scrollLeft;
      pista.classList.add('col-arrastrando');
    });
    window.addEventListener('pointermove', function (e) {
      if (!arrastrando) return;
      var dx = e.clientX - inicioX;
      if (Math.abs(dx) > 3) movido = true;
      pista.scrollLeft = inicioScroll - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!arrastrando) return;
      arrastrando = false;
      pista.classList.remove('col-arrastrando');
    });
    pista.addEventListener('click', function (e) {
      if (movido) {
        e.preventDefault();
        e.stopPropagation();
        movido = false;
      }
    }, true);

    var cards = raiz.querySelectorAll('[data-col-card]');
    cards.forEach(function (card) {
      card.addEventListener('touchstart', function () {
        card.classList.add('col-segunda');
      }, { passive: true });
      card.addEventListener('touchend', function () {
        setTimeout(function () { card.classList.remove('col-segunda'); }, 1200);
      });
    });

    actualizar();
  }

  var todos = document.querySelectorAll('[data-coleccion-uc]');
  todos.forEach(function (raiz) {
    if (raiz.getAttribute('data-col-listo')) return;
    raiz.setAttribute('data-col-listo', '1');
    iniciarCarrusel(raiz);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["categorias-carrusel-uc"] && !Shopify.designMode) return;
  try {
    
(function () {
  var raiz = document.querySelector('[data-categorias-uc]');
  if (!raiz) return;

  var pista = raiz.querySelector('[data-cat-pista]');
  var prev = raiz.querySelector('[data-cat-prev]');
  var next = raiz.querySelector('[data-cat-next]');
  if (!pista) return;

  function maxScroll() {
    return pista.scrollWidth - pista.clientWidth;
  }

  function actualizar() {
    var fin = maxScroll();
    if (prev) prev.classList.toggle('cat-inactiva', pista.scrollLeft <= 2);
    if (next) next.classList.toggle('cat-inactiva', pista.scrollLeft >= fin - 2);
  }

  function paso() {
    var card = pista.querySelector('.categorias-uc__card');
    var ancho = card ? (card.offsetWidth + 16) : pista.clientWidth * 0.8;
    var cantidad = Math.max(1, Math.floor(pista.clientWidth / ancho)) * ancho;
    return cantidad;
  }

  if (prev) prev.addEventListener('click', function () { pista.scrollBy({ left: -paso(), behavior: 'smooth' }); });
  if (next) next.addEventListener('click', function () { pista.scrollBy({ left: paso(), behavior: 'smooth' }); });

  pista.addEventListener('scroll', function () { window.requestAnimationFrame(actualizar); });
  window.addEventListener('resize', actualizar);
  window.addEventListener('load', actualizar);
  setTimeout(actualizar, 300);

  var arrastrando = false;
  var inicioX = 0;
  var inicioScroll = 0;
  var movido = false;

  pista.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse') return;
    arrastrando = true;
    movido = false;
    inicioX = e.clientX;
    inicioScroll = pista.scrollLeft;
    pista.classList.add('cat-arrastrando');
  });
  window.addEventListener('pointermove', function (e) {
    if (!arrastrando) return;
    var dx = e.clientX - inicioX;
    if (Math.abs(dx) > 3) movido = true;
    pista.scrollLeft = inicioScroll - dx;
  });
  window.addEventListener('pointerup', function () {
    if (!arrastrando) return;
    arrastrando = false;
    pista.classList.remove('cat-arrastrando');
  });
  pista.addEventListener('click', function (e) {
    if (movido) {
      e.preventDefault();
      e.stopPropagation();
      movido = false;
    }
  }, true);

  actualizar();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chat-wha"] && !Shopify.designMode) return;
  try {
    
(function () {
  var raiz = document.querySelector('[data-wa-uc]');
  if (!raiz) return;

  var usaPanel = raiz.getAttribute('data-panel') === '1';
  var btn = raiz.querySelector('[data-wa-toggle]');
  var panel = raiz.querySelector('[data-wa-panel]');
  var cerrar = raiz.querySelector('[data-wa-cerrar]');
  var CLAVE = 'wa_uc_urban_v1';
  var dias = parseInt(raiz.getAttribute('data-dias') || '0', 10);

  function marcar() { try { localStorage.setItem(CLAVE, String(Date.now())); } catch (e) {} }
  function ocultoReciente() {
    try {
      var t = parseInt(localStorage.getItem(CLAVE) || '0', 10);
      if (!t || dias <= 0) return false;
      return (Date.now() - t) < dias * 86400000;
    } catch (e) { return false; }
  }
  function abrir() { raiz.classList.add('uc-abierto'); if (panel) panel.setAttribute('aria-hidden', 'false'); }
  function cerrarP() { raiz.classList.remove('uc-abierto'); if (panel) panel.setAttribute('aria-hidden', 'true'); marcar(); }

  if (usaPanel && btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (raiz.classList.contains('uc-abierto')) { cerrarP(); }
      else { abrir(); }
    });
    if (cerrar) cerrar.addEventListener('click', function (e) { e.stopPropagation(); cerrarP(); });
    document.addEventListener('click', function (e) {
      if (raiz.classList.contains('uc-abierto') && !raiz.contains(e.target)) cerrarP();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') cerrarP(); });

    if (raiz.getAttribute('data-auto') === '1' && !ocultoReciente()) {
      var retraso = parseInt(raiz.getAttribute('data-retraso') || '6', 10);
      setTimeout(function () { if (!raiz.classList.contains('uc-abierto')) abrir(); }, retraso * 1000);
    }
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cuadricula-productos"] && !Shopify.designMode) return;
  try {
    
(function () {
  var grids = document.querySelectorAll('[data-cuadricula-uc]');
  if (!grids.length) return;

  function agregarDesde(btn) {
    var vid = btn.getAttribute('data-vid');
    if (!vid) return;
    var card = btn.closest('[data-prod-card]') || document.body;
    var f = document.createElement('form');
    f.method = 'post';
    f.action = '/cart/add';
    f.style.display = 'none';
    f.innerHTML = '<input type="hidden" name="id" value="' + vid + '"><input type="hidden" name="quantity" value="1">';
    card.appendChild(f);
    f.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    setTimeout(function () { if (f.parentNode) f.parentNode.removeChild(f); }, 80);
  }

  function cerrarTallas(scope) {
    (scope || document).querySelectorAll('.tarjeta-uc.uc-tallas-abierto').forEach(function (c) {
      c.classList.remove('uc-tallas-abierto');
    });
  }
  function cerrarSidebar(grid) {
    var sb = grid.querySelector('[data-prod-sidebar]');
    var ov = grid.querySelector('[data-prod-overlay]');
    if (sb) { sb.classList.remove('uc-activo'); sb.setAttribute('aria-hidden', 'true'); }
    if (ov) ov.classList.remove('uc-activo');
    document.body.style.overflow = '';
  }

  grids.forEach(function (grid) {
    grid.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-prod-toggle]');
      if (toggle) {
        var card = toggle.closest('[data-prod-card]');
        if (!card) return;
        var abierto = card.classList.contains('uc-tallas-abierto');
        cerrarTallas(grid);
        if (!abierto) card.classList.add('uc-tallas-abierto');
        return;
      }
      var talla = e.target.closest('[data-prod-cerrar]');
      if (talla) {
        var addBtn = e.target.closest('[data-prod-add]');
        if (addBtn) agregarDesde(addBtn);
        var c = talla.closest('[data-prod-card]');
        if (c) setTimeout(function () { c.classList.remove('uc-tallas-abierto'); }, 180);
        return;
      }
      var addSolo = e.target.closest('[data-prod-add]');
      if (addSolo) {
        agregarDesde(addSolo);
        return;
      }
      var fdrop = e.target.closest('[data-prod-fdrop]');
      if (fdrop) {
        var cont = fdrop.closest('[data-prod-filtro]');
        if (cont) cont.classList.toggle('cuadricula-uc__grupo--abierto');
        return;
      }
      if (e.target.closest('[data-prod-filtros-abrir]')) {
        var sb = grid.querySelector('[data-prod-sidebar]');
        var ov = grid.querySelector('[data-prod-overlay]');
        if (sb) { sb.classList.add('uc-activo'); sb.setAttribute('aria-hidden', 'false'); }
        if (ov) ov.classList.add('uc-activo');
        document.body.style.overflow = 'hidden';
        return;
      }
      if (e.target.closest('[data-prod-filtros-cerrar]') || e.target.closest('[data-prod-overlay]')) {
        cerrarSidebar(grid);
        return;
      }
    });

    var sort = grid.querySelector('[data-prod-sort]');
    if (sort) {
      sort.addEventListener('change', function () {
        var u = new URL(window.location.href);
        u.searchParams.set('sort_by', sort.value);
        u.searchParams.delete('page');
        window.location.href = u.toString();
      });
    }

    var form = grid.querySelector('[data-prod-filtros-form]');
    if (form) {
      form.querySelectorAll('input[type="checkbox"]').forEach(function (inp) {
        inp.addEventListener('change', function () { form.submit(); });
      });
    }
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-prod-card]')) cerrarTallas(document);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      cerrarTallas(document);
      grids.forEach(function (g) { cerrarSidebar(g); });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["futbol-uc"] && !Shopify.designMode) return;
  try {
    
(function () {
  var raiz = document.querySelector('[data-futbol-uc]');
  if (!raiz) return;
  var tabs = raiz.querySelectorAll('[data-fb-tab]');
  var paneles = raiz.querySelectorAll('[data-fb-panel]');
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var idx = tab.getAttribute('data-fb-tab');
      tabs.forEach(function (t) { t.classList.remove('futbol-uc__tab--activo'); });
      tab.classList.add('futbol-uc__tab--activo');
      paneles.forEach(function (p) {
        p.classList.toggle('futbol-uc__panel--activo', p.getAttribute('data-fb-panel') === idx);
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hombre-mujer"] && !Shopify.designMode) return;
  try {
    
(function () {
  var raiz = document.querySelector('[data-genero-uc]');
  if (!raiz) return;
  raiz.querySelectorAll('.genero-uc__chip[data-href]').forEach(function (chip) {
    chip.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var url = chip.getAttribute('data-href');
      if (url && url !== '#') window.location.href = url;
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-populares-uc"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(raiz) {
    var track = raiz.querySelector('[data-pop-track]');
    if (!track) return;
    var prev = raiz.querySelector('[data-pop-prev]');
    var next = raiz.querySelector('[data-pop-next]');

    function paso() {
      var card = track.querySelector('.populares-uc__card');
      if (!card) return track.clientWidth;
      var gap = parseInt(getComputedStyle(track).columnGap, 10) || 16;
      return (card.getBoundingClientRect().width + gap) * Math.max(1, Math.floor(track.clientWidth / (card.getBoundingClientRect().width + gap)));
    }

    function actualizarFlechas() {
      if (!prev || !next) return;
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -paso(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: paso(), behavior: 'smooth' }); });

    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(actualizarFlechas);
    }, { passive: true });
    window.addEventListener('resize', actualizarFlechas);
    actualizarFlechas();
  }

  document.querySelectorAll('[data-populares-uc]').forEach(function (raiz) {
    if (raiz.getAttribute('data-pop-listo')) return;
    raiz.setAttribute('data-pop-listo', '1');
    iniciar(raiz);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hover-urban"] && !Shopify.designMode) return;
  try {
    
(function () {
  var raiz = document.querySelector('[data-hero-uc]');
  if (!raiz) return;

  var pista = raiz.querySelector('[data-hero-pista]');
  var slides = raiz.querySelectorAll('[data-hero-slide]');
  var barras = raiz.querySelectorAll('[data-hero-ir]');
  var autoplay = raiz.getAttribute('data-autoplay') === '1';
  var intervalo = parseInt(raiz.getAttribute('data-intervalo'), 10) || 6000;
  var total = slides.length;
  var actual = 0;
  var temporizador = null;

  if (total <= 1) {
    if (autoplay) autoplay = false;
  }

  function pintarBarras() {
    barras.forEach(function (barra, i) {
      var relleno = barra.querySelector('.hero-uc__barra-relleno');
      if (!relleno) return;
      relleno.style.transition = 'none';
      if (i < actual) {
        relleno.style.width = '100%';
      } else if (i > actual) {
        relleno.style.width = '0%';
      } else {
        relleno.style.width = '0%';
        void relleno.offsetWidth;
        if (autoplay) {
          relleno.style.transition = 'width ' + intervalo + 'ms linear';
        }
        relleno.style.width = '100%';
      }
    });
  }

  function irA(i) {
    actual = (i + total) % total;
    if (pista) pista.style.transform = 'translateX(-' + (actual * 100) + '%)';
    pintarBarras();
  }

  function siguiente() {
    irA(actual + 1);
  }

  function iniciar() {
    if (!autoplay) return;
    detener();
    temporizador = setInterval(siguiente, intervalo);
  }

  function detener() {
    if (temporizador) {
      clearInterval(temporizador);
      temporizador = null;
    }
  }

  barras.forEach(function (barra) {
    barra.addEventListener('click', function () {
      irA(parseInt(barra.getAttribute('data-hero-ir'), 10));
      iniciar();
    });
  });

  var slider = raiz.querySelector('[data-hero-slider]');
  if (slider) {
    slider.addEventListener('mouseenter', detener);
    slider.addEventListener('mouseleave', iniciar);

    var inicioX = 0;
    var moviendo = false;
    slider.addEventListener('touchstart', function (e) {
      inicioX = e.touches[0].clientX;
      moviendo = true;
      detener();
    }, { passive: true });
    slider.addEventListener('touchend', function (e) {
      if (!moviendo) return;
      moviendo = false;
      var dif = e.changedTouches[0].clientX - inicioX;
      if (Math.abs(dif) > 45) {
        if (dif < 0) siguiente(); else irA(actual - 1);
      }
      iniciar();
    });
  }

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) detener(); else iniciar();
  });

  irA(0);
  iniciar();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["modo-deporte-uc"] && !Shopify.designMode) return;
  try {
    
(function () {
  var raiz = document.querySelector('[data-pdep-uc]');
  if (!raiz) return;
  var rot = raiz.querySelector('[data-pdep-rot]');
  if (!rot) return;
  var span = rot.querySelector('.pdep-uc__rot-word');
  var crudas = (raiz.getAttribute('data-palabras') || '').split('||').filter(Boolean);
  if (crudas.length <= 1) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var i = 0;
  span.textContent = crudas[0];
  setInterval(function () {
    rot.classList.add('pdep-uc__rot--out');
    setTimeout(function () {
      i = (i + 1) % crudas.length;
      span.textContent = crudas[i];
      rot.classList.remove('pdep-uc__rot--out');
    }, 280);
  }, 2200);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["notificacion-social-uc"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(raiz) {
    if (raiz.getAttribute('data-activo') !== '1') return;

    var datosEl = raiz.querySelector('[data-notif-productos]');
    if (!datosEl) return;
    var productos = [];
    try { productos = JSON.parse(datosEl.textContent); } catch (e) { return; }
    if (!productos.length) return;

    var KEY_CERRADO = 'notifuc_cerrado_en';
    function leer(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
    function guardar(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }

    var frecuencia = parseFloat(raiz.getAttribute('data-frecuencia'));
    if (isNaN(frecuencia)) frecuencia = 6;
    var cerradoEn = parseInt(leer(KEY_CERRADO), 10);
    if (!isNaN(cerradoEn) && (Date.now() - cerradoEn) / 3600000 < frecuencia) return;

    var retraso = parseFloat(raiz.getAttribute('data-retraso'));
    if (isNaN(retraso)) retraso = 4;
    var duracion = parseFloat(raiz.getAttribute('data-duracion'));
    if (isNaN(duracion)) duracion = 5;
    var intervalo = parseFloat(raiz.getAttribute('data-intervalo'));
    if (isNaN(intervalo)) intervalo = 12;
    var maxDias = parseInt(raiz.getAttribute('data-max-dias'), 10) || 6;

    function lista(attr, fallback) {
      var raw = (raiz.getAttribute(attr) || '').split(/[\n,]+/).map(function (x) { return x.trim(); }).filter(Boolean);
      return raw.length ? raw : fallback;
    }
    var nombres = lista('data-nombres', ['Andrés', 'Laura', 'Santiago', 'Valentina', 'Juan', 'Mariana']);
    var ciudades = lista('data-ciudades', ['Medellín', 'Bogotá', 'Cali', 'Barranquilla']);
    var verbos = lista('data-verbos', ['compró', 'acaba de comprar']);
    var textoVerif = raiz.getAttribute('data-verificado') || 'Verificado';

    var imgEl = raiz.querySelector('[data-notif-img]');
    var personaEl = raiz.querySelector('[data-notif-persona]');
    var verboEl = raiz.querySelector('[data-notif-verbo]');
    var tituloEl = raiz.querySelector('[data-notif-titulo]');
    var tiempoEl = raiz.querySelector('[data-notif-tiempo]');
    var verifEl = raiz.querySelector('[data-notif-verif]');
    var enlaceEl = raiz.querySelector('[data-notif-enlace]');
    var ojoEl = raiz.querySelector('[data-notif-ojo]');
    var cerrarBtn = raiz.querySelector('[data-notif-cerrar]');

    if (verifEl) verifEl.textContent = textoVerif;

    function azar(arr) { return arr[Math.floor(Math.random() * arr.length)]; }

    function tiempoTexto() {
      if (Math.random() < 0.45) {
        var min = Math.floor(Math.random() * 55) + 4;
        return 'hace ' + min + ' minutos';
      }
      if (Math.random() < 0.6) {
        var h = Math.floor(Math.random() * 23) + 1;
        return 'hace ' + h + (h === 1 ? ' hora' : ' horas');
      }
      var d = Math.floor(Math.random() * maxDias) + 1;
      return 'hace ' + d + (d === 1 ? ' día' : ' días');
    }

    var orden = productos.slice();
    for (var i = orden.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = orden[i]; orden[i] = orden[j]; orden[j] = tmp;
    }
    var puntero = 0;
    var visible = false;
    var timerOcultar = null;
    var timerSiguiente = null;

    function construir() {
      var p = orden[puntero % orden.length];
      puntero++;
      if (imgEl) { imgEl.src = p.img; imgEl.alt = p.titulo; }
      if (personaEl) personaEl.textContent = azar(nombres) + ' (' + azar(ciudades) + ')';
      if (verboEl) verboEl.textContent = azar(verbos);
      if (tituloEl) tituloEl.textContent = p.titulo;
      if (tiempoEl) tiempoEl.textContent = tiempoTexto();
      if (enlaceEl) enlaceEl.setAttribute('href', p.url);
      if (ojoEl) ojoEl.setAttribute('href', p.url);
    }

    function mostrar() {
      construir();
      raiz.classList.add('notif-uc--visible');
      visible = true;
      timerOcultar = setTimeout(ocultar, duracion * 1000);
    }
    function ocultar() {
      raiz.classList.remove('notif-uc--visible');
      visible = false;
      timerSiguiente = setTimeout(mostrar, intervalo * 1000);
    }

    if (cerrarBtn) {
      cerrarBtn.addEventListener('click', function (e) {
        e.preventDefault();
        raiz.classList.remove('notif-uc--visible');
        if (timerOcultar) clearTimeout(timerOcultar);
        if (timerSiguiente) clearTimeout(timerSiguiente);
        guardar(KEY_CERRADO, String(Date.now()));
      });
    }

    setTimeout(mostrar, Math.max(0, retraso) * 1000);
  }

  document.querySelectorAll('[data-notif-uc]').forEach(function (raiz) {
    if (raiz.getAttribute('data-notif-listo')) return;
    raiz.setAttribute('data-notif-listo', '1');
    iniciar(raiz);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pagbusqueda"] && !Shopify.designMode) return;
  try {
    
(function () {
  var raiz = document.querySelector('[data-busqres-uc]');
  if (!raiz) return;

  var form = raiz.querySelector('[data-busqres-form]');
  if (form) {
    var sort = form.querySelector('[data-busqres-sort]');
    if (sort) sort.addEventListener('change', function () { form.submit(); });
    form.querySelectorAll('[data-busqres-auto]').forEach(function (c) {
      c.addEventListener('change', function () { form.submit(); });
    });
  }

  var abrir = raiz.querySelector('[data-prod-filtros-abrir]');
  var sidebar = raiz.querySelector('[data-prod-sidebar]');
  var overlay = raiz.querySelector('[data-prod-overlay]');
  function abrirF() { if (sidebar) sidebar.classList.add('uc-activo'); if (overlay) overlay.classList.add('uc-activo'); document.body.style.overflow = 'hidden'; }
  function cerrarF() { if (sidebar) sidebar.classList.remove('uc-activo'); if (overlay) overlay.classList.remove('uc-activo'); document.body.style.overflow = ''; }
  if (abrir) abrir.addEventListener('click', abrirF);
  if (overlay) overlay.addEventListener('click', cerrarF);
  raiz.querySelectorAll('[data-prod-filtros-cerrar]').forEach(function (b) { b.addEventListener('click', cerrarF); });

  function agregar(btn) {
    var card = btn.closest('[data-prod-card]');
    var vid = btn.getAttribute('data-vid');
    if (!card || !vid) return;
    var f = document.createElement('form');
    f.action = '/cart/add'; f.method = 'post'; f.style.display = 'none';
    var i = document.createElement('input'); i.type = 'hidden'; i.name = 'id'; i.value = vid; f.appendChild(i);
    card.appendChild(f);
    f.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    setTimeout(function () { if (f.parentNode) f.parentNode.removeChild(f); }, 1500);
  }

  raiz.addEventListener('click', function (e) {
    var drop = e.target.closest('[data-prod-fdrop]');
    if (drop) { var g = drop.closest('[data-prod-filtro]'); if (g) g.classList.toggle('busqres-uc__grupo--abierto'); return; }
    var tog = e.target.closest('[data-prod-toggle]');
    if (tog) { var c = tog.closest('[data-prod-card]'); if (c) c.classList.toggle('busqres-uc__card--tallas'); return; }
    var add = e.target.closest('[data-prod-add]');
    if (add) { e.preventDefault(); agregar(add); var cc = add.closest('[data-prod-card]'); if (cc) cc.classList.remove('busqres-uc__card--tallas'); return; }
    var card = e.target.closest('[data-prod-card]');
    if (!card) { raiz.querySelectorAll('.busqres-uc__card--tallas').forEach(function (x) { x.classList.remove('busqres-uc__card--tallas'); }); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pagina-basquet"] && !Shopify.designMode) return;
  try {
    
(function () {
  var raiz = document.querySelector('[data-basquet-uc]');
  if (!raiz) return;
  var tabs = raiz.querySelectorAll('[data-bk-tab]');
  var paneles = raiz.querySelectorAll('[data-bk-panel]');
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var idx = tab.getAttribute('data-bk-tab');
      tabs.forEach(function (t) { t.classList.remove('basquet-uc__tab--activo'); });
      tab.classList.add('basquet-uc__tab--activo');
      paneles.forEach(function (p) {
        p.classList.toggle('basquet-uc__panel--activo', p.getAttribute('data-bk-panel') === idx);
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pagina-gym"] && !Shopify.designMode) return;
  try {
    
(function () {
  var raiz = document.querySelector('[data-gym-uc]');
  if (!raiz) return;
  var tabs = raiz.querySelectorAll('[data-gy-tab]');
  var paneles = raiz.querySelectorAll('[data-gy-panel]');
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var idx = tab.getAttribute('data-gy-tab');
      tabs.forEach(function (t) { t.classList.remove('gym-uc__tab--activo'); });
      tab.classList.add('gym-uc__tab--activo');
      paneles.forEach(function (p) {
        p.classList.toggle('gym-uc__panel--activo', p.getAttribute('data-gy-panel') === idx);
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pagina-marcas"] && !Shopify.designMode) return;
  try {
    
(function () {
  var raiz = document.querySelector('[data-marcas-uc]');
  if (!raiz) return;

  var pills = raiz.querySelector('[data-marcas-pills]');
  var buscar = raiz.querySelector('[data-marcas-buscar]');
  var vacio = raiz.querySelector('[data-marcas-vacio]');
  var grupos = raiz.querySelectorAll('[data-letra-grupo]');
  var items = raiz.querySelectorAll('[data-marca]');
  var destBloque = raiz.querySelector('[data-marcas-dest]');
  var destGrid = raiz.querySelector('[data-marcas-destacadas]');

  var catActiva = '';
  var consulta = '';

  function filtrar() {
    var visiblesTotales = 0;
    items.forEach(function (it) {
      var cat = it.getAttribute('data-categoria');
      var nom = it.getAttribute('data-nombre') || '';
      var okCat = catActiva === '' || cat === null || cat === catActiva;
      var okBuscar = consulta === '' || nom.indexOf(consulta) !== -1;
      var ver = okCat && okBuscar;
      it.style.display = ver ? '' : 'none';
      if (ver) visiblesTotales++;
    });
    grupos.forEach(function (g) {
      var visibles = g.querySelectorAll('[data-marca]:not([style*="display: none"])');
      g.style.display = visibles.length ? '' : 'none';
    });
    if (destBloque && destGrid) {
      var destVis = destGrid.querySelectorAll('[data-marca]:not([style*="display: none"])');
      destBloque.style.display = destVis.length ? '' : 'none';
    }
    if (vacio) vacio.hidden = visiblesTotales !== 0;
  }

  if (pills) {
    pills.addEventListener('click', function (e) {
      var b = e.target.closest('[data-cat]');
      if (!b) return;
      pills.querySelectorAll('.marcas-uc__pill').forEach(function (p) {
        p.classList.remove('marcas-uc__pill--activa');
      });
      b.classList.add('marcas-uc__pill--activa');
      catActiva = b.getAttribute('data-cat') || '';
      var titulo = raiz.querySelector('[data-marcas-titulo]');
      if (titulo) {
        if (catActiva === '') {
          titulo.textContent = titulo.getAttribute('data-default');
        } else {
          titulo.textContent = b.textContent.trim();
        }
      }
      filtrar();
    });
  }

  if (buscar) {
    buscar.addEventListener('input', function () {
      consulta = buscar.value.trim().toLowerCase();
      filtrar();
    });
  }

  raiz.addEventListener('click', function (e) {
    var tog = e.target.closest('[data-letra-tog]');
    if (tog) {
      var g = tog.closest('[data-letra-grupo]');
      if (g) g.classList.toggle('marcas-uc__grupo--abierto');
      return;
    }
    var abc = e.target.closest('.marcas-uc__abc-letra[href]');
    if (abc) {
      var id = abc.getAttribute('href');
      var destino = id && id.charAt(0) === '#' ? raiz.querySelector(id) : null;
      if (destino) {
        e.preventDefault();
        destino.classList.add('marcas-uc__grupo--abierto');
        destino.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pagina-running"] && !Shopify.designMode) return;
  try {
    
(function () {
  var raiz = document.querySelector('[data-running-uc]');
  if (!raiz) return;
  var tabs = raiz.querySelectorAll('[data-rn-tab]');
  var paneles = raiz.querySelectorAll('[data-rn-panel]');
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var idx = tab.getAttribute('data-rn-tab');
      tabs.forEach(function (t) { t.classList.remove('running-uc__tab--activo'); });
      tab.classList.add('running-uc__tab--activo');
      paneles.forEach(function (p) {
        p.classList.toggle('running-uc__panel--activo', p.getAttribute('data-rn-panel') === idx);
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["paginaproductouc"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(raiz) {
    var datosEl = raiz.querySelector('[data-prod-variantes]');
    if (!datosEl) return;
    var variantes = [];
    try { variantes = JSON.parse(datosEl.textContent); } catch (e) { return; }

    var formato = raiz.getAttribute('data-money-format') || '${{amount}}';
    var soloDefault = raiz.getAttribute('data-solo-default') === '1';

    var form = raiz.querySelector('[data-prod-form]');
    var idInput = raiz.querySelector('[data-prod-id]');
    var precioEl = raiz.querySelector('[data-prod-precio]');
    var antesEl = raiz.querySelector('[data-prod-antes]');
    var badgeEl = raiz.querySelector('[data-prod-badge]');
    var avisoEl = raiz.querySelector('[data-prod-aviso]');
    var btnAgregar = raiz.querySelector('[data-prod-agregar]');
    var btnAgregarTexto = raiz.querySelector('[data-prod-agregar-texto]');
    var btnComprar = raiz.querySelector('[data-prod-comprar]');
    var grupos = raiz.querySelectorAll('[data-prod-opcion]');
    var principal = raiz.querySelector('[data-prod-principal]');
    var thumbs = raiz.querySelectorAll('[data-prod-thumb]');
    var dots = raiz.querySelectorAll('[data-prod-dot]');
    var cantInput = raiz.querySelector('[data-prod-cant]');

    var stickyEl = raiz.querySelector('[data-prod-sticky]');
    var stickyPrecio = raiz.querySelector('[data-prod-sticky-precio]');
    var stickyImg = raiz.querySelector('[data-prod-sticky-img]');
    var stickySelects = raiz.querySelectorAll('[data-prod-sticky-select]');
    var stickyAdd = raiz.querySelector('[data-prod-sticky-add]');
    var stickyAddTexto = raiz.querySelector('[data-prod-sticky-add-texto]');

    var textoAgregar = btnAgregarTexto ? btnAgregarTexto.textContent : 'Agregar';
    var textoAgotado = raiz.getAttribute('data-texto-agotado') || 'AGOTADO';
    var textoElegir = raiz.getAttribute('data-texto-elegir') || 'Selecciona tu talla';
    var hayDisponibles = variantes.some(function (v) { return v.available; });
    var seleccion = [];
    for (var s = 0; s < grupos.length; s++) { seleccion.push(''); }

    function formatearDinero(centavos) {
      var num = Number(centavos);
      function sep(n, p, miles, dec) {
        p = p == null ? 2 : p; miles = miles || ','; dec = dec || '.';
        if (isNaN(n)) return '0';
        n = (n / 100).toFixed(p);
        var partes = n.split('.');
        var ent = partes[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + miles);
        return ent + (partes[1] ? dec + partes[1] : '');
      }
      var ph = /\{\{\s*(\w+)\s*\}\}/;
      var m = formato.match(ph);
      if (!m) return formato;
      var val = '';
      switch (m[1]) {
        case 'amount': val = sep(num, 2); break;
        case 'amount_no_decimals': val = sep(num, 0); break;
        case 'amount_with_comma_separator': val = sep(num, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': val = sep(num, 0, '.', ','); break;
        case 'amount_with_apostrophe_separator': val = sep(num, 2, "'", '.'); break;
        case 'amount_with_space_separator': val = sep(num, 2, ' ', '.'); break;
        case 'amount_no_decimals_with_space_separator': val = sep(num, 0, ' ', '.'); break;
        default: val = sep(num, 2);
      }
      return formato.replace(ph, val);
    }

    function varianteActual() {
      if (soloDefault) return variantes[0];
      for (var k = 0; k < seleccion.length; k++) { if (!seleccion[k]) return null; }
      return variantes.find(function (v) {
        return v.options.every(function (val, i) { return val === seleccion[i]; });
      }) || null;
    }

    function valorDisponible(pos, val) {
      return variantes.some(function (v) {
        if (!v.available) return false;
        if (v.options[pos] !== val) return false;
        for (var j = 0; j < seleccion.length; j++) {
          if (j !== pos && seleccion[j] && v.options[j] !== seleccion[j]) return false;
        }
        return true;
      });
    }

    function pintarPrecio(v) {
      if (precioEl) {
        precioEl.textContent = formatearDinero(v.price);
        var enOferta = v.compare && v.compare > v.price;
        precioEl.classList.toggle('producto-uc__precio--oferta', !!enOferta);
        if (antesEl) {
          if (enOferta) {
            antesEl.textContent = formatearDinero(v.compare);
            antesEl.hidden = false;
          } else {
            antesEl.hidden = true;
          }
        }
        if (badgeEl) {
          if (enOferta) {
            var pct = Math.round((1 - v.price / v.compare) * 100);
            badgeEl.textContent = '-' + pct + '%';
            badgeEl.style.display = '';
          } else {
            badgeEl.style.display = 'none';
          }
        }
      }
      if (stickyPrecio) stickyPrecio.textContent = formatearDinero(v.price);
    }

    var imagenes = [];
    thumbs.forEach(function (t) {
      imagenes.push({ id: t.getAttribute('data-media-id'), src: t.getAttribute('data-src') });
    });
    var indiceImagen = 0;

    function irAImagen(i, animar) {
      if (!imagenes.length) return;
      if (i < 0) i = imagenes.length - 1;
      if (i >= imagenes.length) i = 0;
      indiceImagen = i;
      if (principal) {
        if (animar) {
          principal.classList.add('prod-cambiando');
          setTimeout(function () {
            principal.src = imagenes[i].src;
            principal.classList.remove('prod-cambiando');
          }, 130);
        } else {
          principal.src = imagenes[i].src;
        }
      }
      thumbs.forEach(function (t, ti) { t.classList.toggle('prod-activo', ti === i); });
      dots.forEach(function (d, di) { d.classList.toggle('prod-activo', di === i); });
      var thumbActivo = thumbs[i];
      if (thumbActivo && thumbActivo.scrollIntoView) {
        try { thumbActivo.scrollIntoView({ block: 'nearest', inline: 'nearest' }); } catch (e) {}
      }
    }

    function cambiarImagen(mediaId) {
      if (!mediaId) return;
      for (var i = 0; i < imagenes.length; i++) {
        if (imagenes[i].id == mediaId) { irAImagen(i, true); return; }
      }
    }

    function actualizarSticky(v, completo) {
      if (!stickyEl) return;
      if (stickyImg && v && v.media) {
        for (var i = 0; i < imagenes.length; i++) {
          if (imagenes[i].id == v.media) { stickyImg.src = imagenes[i].src; break; }
        }
      }
      stickySelects.forEach(function (sel) {
        var pos = parseInt(sel.getAttribute('data-pos'), 10);
        if (seleccion[pos] && sel.value !== seleccion[pos]) sel.value = seleccion[pos];
        Array.prototype.forEach.call(sel.options, function (op) {
          if (!op.value) return;
          op.disabled = !valorDisponible(pos, op.value);
        });
      });
      if (stickyAdd) {
        if (btnAgregar) stickyAdd.disabled = btnAgregar.disabled && !hayDisponibles;
        else stickyAdd.disabled = false;
      }
      if (stickyAddTexto && btnAgregarTexto) stickyAddTexto.textContent = btnAgregarTexto.textContent;
    }

    function actualizarMarcas() {
      grupos.forEach(function (grupo) {
        var pos = parseInt(grupo.getAttribute('data-pos'), 10);
        var botones = grupo.querySelectorAll('[data-prod-valor]');
        botones.forEach(function (btn) {
          var val = btn.getAttribute('data-valor');
          var disp = valorDisponible(pos, val);
          btn.classList.toggle('prod-agotado', !disp);
        });
        var valEl = grupo.querySelector('[data-prod-opcion-valor]');
        if (valEl) valEl.textContent = seleccion[pos] ? seleccion[pos] : '';
      });
    }

    function fijarEstado() {
      var v = varianteActual();
      var completo = true;
      if (!soloDefault) {
        for (var k = 0; k < seleccion.length; k++) { if (!seleccion[k]) { completo = false; break; } }
      }

      if (!completo) {
        if (idInput) idInput.value = '';
        if (hayDisponibles) {
          if (avisoEl) avisoEl.hidden = false;
          if (btnAgregar) { btnAgregar.disabled = true; btnAgregar.classList.add('prod-elegir'); }
          if (btnComprar) { btnComprar.disabled = true; btnComprar.classList.add('prod-elegir'); }
          if (btnAgregarTexto) btnAgregarTexto.textContent = textoElegir;
        } else {
          if (avisoEl) avisoEl.hidden = true;
          if (btnAgregar) { btnAgregar.disabled = true; btnAgregar.classList.remove('prod-elegir'); }
          if (btnComprar) { btnComprar.disabled = true; btnComprar.classList.remove('prod-elegir'); }
          if (btnAgregarTexto) btnAgregarTexto.textContent = textoAgotado;
        }
        actualizarSticky(v, completo);
        return;
      }

      if (avisoEl) avisoEl.hidden = true;

      if (!v || !v.available) {
        if (idInput) idInput.value = v ? v.id : '';
        if (btnAgregar) { btnAgregar.disabled = true; btnAgregar.classList.remove('prod-elegir'); }
        if (btnComprar) { btnComprar.disabled = true; btnComprar.classList.remove('prod-elegir'); }
        if (btnAgregarTexto) btnAgregarTexto.textContent = textoAgotado;
        actualizarSticky(v, completo);
        return;
      }

      if (idInput) idInput.value = v.id;
      if (btnAgregar) { btnAgregar.disabled = false; btnAgregar.classList.remove('prod-elegir'); }
      if (btnComprar) { btnComprar.disabled = false; btnComprar.classList.remove('prod-elegir'); }
      if (btnAgregarTexto) btnAgregarTexto.textContent = textoAgregar;
      pintarPrecio(v);
      if (v.media) cambiarImagen(v.media);
      actualizarSticky(v, completo);
    }

    function elegirValor(pos, val) {
      seleccion[pos] = val;
      grupos.forEach(function (grupo) {
        if (parseInt(grupo.getAttribute('data-pos'), 10) !== pos) return;
        grupo.querySelectorAll('[data-prod-valor]').forEach(function (b) {
          b.classList.toggle('prod-activo', b.getAttribute('data-valor') === val);
        });
      });
      actualizarMarcas();
      fijarEstado();
    }

    grupos.forEach(function (grupo) {
      var pos = parseInt(grupo.getAttribute('data-pos'), 10);
      grupo.querySelectorAll('[data-prod-valor]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.classList.contains('prod-agotado')) return;
          elegirValor(pos, btn.getAttribute('data-valor'));
        });
      });
    });

    stickySelects.forEach(function (sel) {
      sel.addEventListener('change', function () {
        var pos = parseInt(sel.getAttribute('data-pos'), 10);
        if (!sel.value) return;
        elegirValor(pos, sel.value);
      });
    });

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        irAImagen(parseInt(thumb.getAttribute('data-index'), 10), true);
      });
    });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        irAImagen(parseInt(dot.getAttribute('data-index'), 10), true);
      });
    });
    var visorPrev = raiz.querySelector('[data-prod-visor-prev]');
    var visorNext = raiz.querySelector('[data-prod-visor-next]');
    if (visorPrev) visorPrev.addEventListener('click', function () { irAImagen(indiceImagen - 1, true); });
    if (visorNext) visorNext.addEventListener('click', function () { irAImagen(indiceImagen + 1, true); });

    var visor = raiz.querySelector('[data-prod-visor]');
    if (visor && imagenes.length > 1) {
      var xIni = 0, yIni = 0, arrastrando = false;
      visor.addEventListener('touchstart', function (e) {
        xIni = e.touches[0].clientX; yIni = e.touches[0].clientY; arrastrando = true;
      }, { passive: true });
      visor.addEventListener('touchend', function (e) {
        if (!arrastrando) return;
        arrastrando = false;
        var dx = e.changedTouches[0].clientX - xIni;
        var dy = e.changedTouches[0].clientY - yIni;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          if (dx < 0) irAImagen(indiceImagen + 1, false);
          else irAImagen(indiceImagen - 1, false);
        }
      }, { passive: true });
    }

    var menos = raiz.querySelector('[data-prod-menos]');
    var mas = raiz.querySelector('[data-prod-mas]');
    function cant() { return Math.max(1, parseInt(cantInput ? cantInput.value : '1', 10) || 1); }
    if (menos) menos.addEventListener('click', function () { if (cantInput) cantInput.value = Math.max(1, cant() - 1); });
    if (mas) mas.addEventListener('click', function () { if (cantInput) cantInput.value = cant() + 1; });

    if (btnComprar) {
      btnComprar.addEventListener('click', function () {
        if (btnComprar.disabled) return;
        var id = idInput ? idInput.value : '';
        if (!id) return;
        btnComprar.classList.add('prod-cargando');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: id, quantity: cant() })
        }).then(function (r) { return r.json(); }).then(function () {
          window.location.href = '/checkout';
        }).catch(function () {
          btnComprar.classList.remove('prod-cargando');
        });
      });
    }

    if (stickyAdd) {
      stickyAdd.addEventListener('click', function () {
        if (btnAgregar && btnAgregar.disabled) {
          var destino = raiz.querySelector('.producto-uc__opciones') || form;
          if (destino && destino.scrollIntoView) destino.scrollIntoView({ behavior: 'smooth', block: 'center' });
          if (avisoEl && hayDisponibles) avisoEl.hidden = false;
          return;
        }
        if (btnAgregar) btnAgregar.click();
      });
    }

    if (soloDefault) {
      fijarEstado();
    } else {
      actualizarMarcas();
      fijarEstado();
    }

    if (stickyEl && btnAgregar && 'IntersectionObserver' in window) {
      var anclaSticky = raiz.querySelector('.producto-uc__botones') || btnAgregar;
      var obs = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (en) {
          var pasado = !en.isIntersecting && en.boundingClientRect.top < 0;
          stickyEl.classList.toggle('prod-visible', pasado);
        });
      }, { threshold: 0 });
      obs.observe(anclaSticky);
    }

    var destacado = raiz.querySelector('[data-prod-destacado]');
    if (destacado) {
      var items = destacado.querySelectorAll('[data-prod-destacado-item]');
      if (items.length > 1) {
        var idxDest = 0;
        setInterval(function () {
          items[idxDest].classList.remove('prod-activo');
          idxDest = (idxDest + 1) % items.length;
          items[idxDest].classList.add('prod-activo');
        }, 4500);
      }
    }

    var irResenas = raiz.querySelector('[data-prod-ir-resenas]');
    var bloqueResenas = raiz.querySelector('[data-prod-resenas]');
    if (irResenas && bloqueResenas) {
      irResenas.addEventListener('click', function () {
        bloqueResenas.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    var track = raiz.querySelector('[data-prod-resenas-track]');
    if (track) {
      var rPrev = raiz.querySelector('[data-prod-resenas-prev]');
      var rNext = raiz.querySelector('[data-prod-resenas-next]');
      function pasoResena() {
        var card = track.querySelector('.producto-uc__resena');
        return card ? card.getBoundingClientRect().width + 14 : 300;
      }
      if (rPrev) rPrev.addEventListener('click', function () { track.scrollBy({ left: -pasoResena(), behavior: 'smooth' }); });
      if (rNext) rNext.addEventListener('click', function () { track.scrollBy({ left: pasoResena(), behavior: 'smooth' }); });
    }

    var viendoActivo = raiz.getAttribute('data-viendo-activo') === '1';
    var viendoNum = raiz.querySelector('[data-prod-viendo-num]');
    if (viendoActivo && viendoNum) {
      var vMin = parseInt(raiz.getAttribute('data-viendo-min'), 10) || 8;
      var vMax = parseInt(raiz.getAttribute('data-viendo-max'), 10) || 30;
      if (vMax < vMin) vMax = vMin;
      function aleatorio(a, b) { return Math.floor(Math.random() * (b - a + 1)) + a; }
      var actual = aleatorio(vMin, vMax);
      viendoNum.textContent = actual;
      setInterval(function () {
        var delta = aleatorio(-2, 2);
        actual += delta;
        if (actual < vMin) actual = vMin + aleatorio(0, 2);
        if (actual > vMax) actual = vMax - aleatorio(0, 2);
        viendoNum.textContent = actual;
      }, 4000);
    }

    var tablaModal = raiz.querySelector('[data-prod-tabla-modal]');
    if (tablaModal) {
      var abrirBtns = raiz.querySelectorAll('[data-prod-tabla-abrir]');
      var cerrarBtns = raiz.querySelectorAll('[data-prod-tabla-cerrar]');
      function abrirTabla() {
        tablaModal.classList.add('prod-abierto');
        document.body.style.overflow = 'hidden';
      }
      function cerrarTabla() {
        tablaModal.classList.remove('prod-abierto');
        document.body.style.overflow = '';
      }
      abrirBtns.forEach(function (b) { b.addEventListener('click', abrirTabla); });
      cerrarBtns.forEach(function (b) { b.addEventListener('click', cerrarTabla); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && tablaModal.classList.contains('prod-abierto')) cerrarTabla();
      });
    }

    var entrega = raiz.querySelector('[data-prod-entrega]');
    if (entrega) {
      var procDias = parseInt(raiz.getAttribute('data-en-proc'), 10) || 4;
      var entregaDias = parseInt(raiz.getAttribute('data-en-entrega'), 10) || 4;
      var procOffset = parseInt(raiz.getAttribute('data-en-offset'), 10);
      if (isNaN(procOffset)) procOffset = 1;
      var formatoEn = raiz.getAttribute('data-en-formato') || 'dmy';
      var meses = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];

      function sumarDias(base, n) {
        var d = new Date(base.getTime());
        d.setDate(d.getDate() + n);
        return d;
      }
      function dosD(n) { return n < 10 ? '0' + n : '' + n; }
      function cortoEn(d) { return meses[d.getMonth()] + ' ' + d.getDate(); }
      function rangoEn(a, b) {
        if (a.getTime() === b.getTime()) return cortoEn(a);
        if (a.getMonth() === b.getMonth()) return meses[a.getMonth()] + ' ' + a.getDate() + ' - ' + b.getDate();
        return cortoEn(a) + ' - ' + cortoEn(b);
      }
      function largoEn(d) {
        var dd = dosD(d.getDate()), mm = dosD(d.getMonth() + 1), yy = d.getFullYear();
        return formatoEn === 'mdy' ? (mm + '/' + dd + '/' + yy) : (dd + '/' + mm + '/' + yy);
      }

      var hoy = new Date();
      var procIni = sumarDias(hoy, procOffset);
      var procFin = sumarDias(hoy, procOffset + Math.max(0, procDias - 1));
      var entIni = sumarDias(procFin, 1);
      var entFin = sumarDias(procFin, Math.max(1, entregaDias));

      var ep1 = entrega.querySelector('[data-en-paso="1"]');
      var ep2 = entrega.querySelector('[data-en-paso="2"]');
      var ep3 = entrega.querySelector('[data-en-paso="3"]');
      var ef1 = entrega.querySelector('[data-en-fecha1]');
      var ef2 = entrega.querySelector('[data-en-fecha2]');
      if (ep1) ep1.textContent = cortoEn(hoy);
      if (ep2) ep2.textContent = rangoEn(procIni, procFin);
      if (ep3) ep3.textContent = rangoEn(entIni, entFin);
      if (ef1) ef1.textContent = largoEn(entIni);
      if (ef2) ef2.textContent = largoEn(entFin);
    }

    var reco = raiz.querySelector('[data-prod-relacionados]');
    if (reco && raiz.getAttribute('data-reco-activo') === '1' && !reco.querySelector('.producto-uc__reco-grid')) {
      var recoUrl = raiz.getAttribute('data-reco-url');
      var recoId = raiz.getAttribute('data-reco-id');
      var recoLim = raiz.getAttribute('data-reco-limite') || '8';
      var recoSec = raiz.getAttribute('data-section-id');
      if (recoUrl && recoId) {
        var url = recoUrl + '?section_id=' + encodeURIComponent(recoSec) + '&product_id=' + encodeURIComponent(recoId) + '&limit=' + encodeURIComponent(recoLim) + '&intent=related';
        fetch(url).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nuevo = doc.querySelector('[data-prod-relacionados]');
          if (nuevo && nuevo.innerHTML.trim()) reco.innerHTML = nuevo.innerHTML;
        }).catch(function () {});
      }
    }
  }

  document.querySelectorAll('[data-producto-uc]').forEach(function (raiz) {
    if (raiz.getAttribute('data-prod-listo')) return;
    raiz.setAttribute('data-prod-listo', '1');
    iniciar(raiz);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup-de-descuento"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(raiz) {
    if (raiz.getAttribute('data-activo') !== '1') return;

    var caja = raiz.querySelector('.oepop__caja');
    var tarjeta = raiz.querySelector('[data-oepop-tarjeta]');
    var form = raiz.querySelector('[data-oepop-form]');
    var email = raiz.querySelector('[data-oepop-email]');
    var enviar = raiz.querySelector('[data-oepop-enviar]');
    var errorEl = raiz.querySelector('[data-oepop-error]');
    var copiarBtn = raiz.querySelector('[data-oepop-copiar]');
    var codigoEl = raiz.querySelector('[data-oepop-codigo]');
    var timer1 = raiz.querySelector('[data-oepop-timer]');
    var timer2 = raiz.querySelector('[data-oepop-timer2]');
    var cerrarBtns = raiz.querySelectorAll('[data-oepop-cerrar]');

    var tab = document.querySelector('[data-oepop-abrir]');

    var minutos = parseInt(raiz.getAttribute('data-minutos'), 10) || 15;
    var retraso = parseInt(raiz.getAttribute('data-retraso'), 10);
    if (isNaN(retraso)) retraso = 6;
    var usarExit = raiz.getAttribute('data-exit') === '1';
    var frecuencia = parseInt(raiz.getAttribute('data-frecuencia'), 10);
    if (isNaN(frecuencia)) frecuencia = 3;
    var codigo = raiz.getAttribute('data-codigo') || '';
    var textoCopiado = raiz.getAttribute('data-copiado') || 'Copiado';
    var tags = raiz.getAttribute('data-tags') || 'newsletter';

    var KEY_ESTADO = 'oepop_estado';
    var KEY_CERRADO = 'oepop_cerrado_en';
    var KEY_EXPIRA = 'oepop_expira';

    function leer(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
    function guardar(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }

    var suscrito = leer(KEY_ESTADO) === 'suscrito';

    function expiracion() {
      var exp = parseInt(leer(KEY_EXPIRA), 10);
      var ahora = Date.now();
      if (isNaN(exp) || exp < ahora) {
        exp = ahora + minutos * 60000;
        guardar(KEY_EXPIRA, String(exp));
      }
      return exp;
    }
    var finTimer = 0;

    function pintarTimer() {
      var restante = Math.max(0, finTimer - Date.now());
      var m = Math.floor(restante / 60000);
      var s = Math.floor((restante % 60000) / 1000);
      var txt = (m < 10 ? '0' + m : m) + ':' + (s < 10 ? '0' + s : s);
      if (timer1) timer1.textContent = txt;
      if (timer2) timer2.textContent = txt;
    }
    var intTimer = null;
    function arrancarTimer() {
      finTimer = expiracion();
      pintarTimer();
      if (intTimer) clearInterval(intTimer);
      intTimer = setInterval(pintarTimer, 1000);
    }

    function abrir() {
      raiz.classList.add('oepop--abierto');
      document.body.style.overflow = 'hidden';
      arrancarTimer();
      if (suscrito && tarjeta) tarjeta.classList.add('oepop--girada');
    }
    function cerrar() {
      raiz.classList.remove('oepop--abierto');
      document.body.style.overflow = '';
      if (!suscrito) guardar(KEY_CERRADO, String(Date.now()));
      mostrarTab();
    }
    function mostrarTab() {
      if (tab) tab.classList.add('oepop--visible');
    }

    cerrarBtns.forEach(function (b) { b.addEventListener('click', cerrar); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && raiz.classList.contains('oepop--abierto')) cerrar();
    });
    if (tab) tab.addEventListener('click', function () {
      tab.classList.remove('oepop--visible');
      abrir();
    });

    function emailValido(v) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
    }

    function girar() {
      if (tarjeta) tarjeta.classList.add('oepop--girada');
    }

    function suscribir(valor) {
      var fd = new FormData();
      fd.append('form_type', 'customer');
      fd.append('utf8', '✓');
      fd.append('contact[email]', valor);
      fd.append('contact[tags]', tags);
      return fetch('/contact', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var valor = (email ? email.value : '').trim();
        if (!emailValido(valor)) {
          if (errorEl) errorEl.hidden = false;
          if (email) {
            email.classList.remove('oepop--malo');
            void email.offsetWidth;
            email.classList.add('oepop--malo');
          }
          return;
        }
        if (errorEl) errorEl.hidden = true;
        if (enviar) enviar.classList.add('oepop--cargando');
        suscrito = true;
        guardar(KEY_ESTADO, 'suscrito');
        suscribir(valor).catch(function () {}).then(function () {
          if (enviar) enviar.classList.remove('oepop--cargando');
        });
        girar();
      });
    }

    if (copiarBtn) {
      copiarBtn.addEventListener('click', function () {
        var textoOriginal = copiarBtn.textContent;
        function ok() {
          copiarBtn.textContent = textoCopiado;
          setTimeout(function () { copiarBtn.textContent = textoOriginal; }, 1800);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(codigo).then(ok).catch(function () { fallback(); });
        } else {
          fallback();
        }
        function fallback() {
          var ta = document.createElement('textarea');
          ta.value = codigo;
          ta.style.position = 'fixed';
          ta.style.opacity = '0';
          document.body.appendChild(ta);
          ta.select();
          try { document.execCommand('copy'); ok(); } catch (e) {}
          document.body.removeChild(ta);
        }
      });
    }

    var puedeAuto = true;
    if (suscrito) {
      puedeAuto = false;
      mostrarTab();
    } else {
      var cerradoEn = parseInt(leer(KEY_CERRADO), 10);
      if (!isNaN(cerradoEn)) {
        var dias = (Date.now() - cerradoEn) / 86400000;
        if (dias < frecuencia) {
          puedeAuto = false;
          mostrarTab();
        }
      }
    }

    var abierto = false;
    function abrirUna() {
      if (abierto) return;
      abierto = true;
      abrir();
    }

    if (puedeAuto) {
      setTimeout(abrirUna, Math.max(0, retraso) * 1000);
      if (usarExit) {
        document.addEventListener('mouseout', function (e) {
          if (!e.relatedTarget && e.clientY <= 0) abrirUna();
        });
      }
    }
  }

  document.querySelectorAll('[data-oepop]').forEach(function (raiz) {
    if (raiz.getAttribute('data-oepop-listo')) return;
    raiz.setAttribute('data-oepop-listo', '1');
    iniciar(raiz);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prueba-social"] && !Shopify.designMode) return;
  try {
    
(function () {
  var raiz = document.querySelector('[data-social-uc]');
  if (!raiz) return;
  var lb = raiz.querySelector('[data-social-lightbox]');
  var lbImg = raiz.querySelector('[data-social-lb-img]');

  function abrir(src) {
    if (!lb || !src) return;
    lbImg.setAttribute('src', src);
    lb.classList.add('uc-activo');
    lb.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function cerrar() {
    if (!lb) return;
    lb.classList.remove('uc-activo');
    lb.setAttribute('aria-hidden', 'true');
    lbImg.setAttribute('src', '');
    document.body.style.overflow = '';
  }

  raiz.querySelectorAll('[data-social-abrir]').forEach(function (card) {
    card.addEventListener('click', function () {
      abrir(card.getAttribute('data-social-img'));
    });
    card.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        abrir(card.getAttribute('data-social-img'));
      }
    });
  });

  var cerrarBtn = raiz.querySelector('[data-social-cerrar]');
  if (cerrarBtn) cerrarBtn.addEventListener('click', cerrar);
  if (lb) lb.addEventListener('click', function (e) { if (e.target === lb) cerrar(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') cerrar(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recomendados-uc"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciarCarrusel(raiz) {
    var pista = raiz.querySelector('[data-rec-pista]');
    var thumb = raiz.querySelector('[data-rec-thumb]');
    var prev = raiz.querySelector('[data-rec-prev]');
    var next = raiz.querySelector('[data-rec-next]');
    if (!pista) return;

    function maxScroll() { return pista.scrollWidth - pista.clientWidth; }

    function actualizar() {
      var ancho = pista.scrollWidth;
      if (ancho <= 0) return;
      var visible = (pista.clientWidth / ancho) * 100;
      if (visible > 100) visible = 100;
      if (visible < 8) visible = 8;
      var rango = 100 - visible;
      var fin = maxScroll();
      var avance = fin > 0 ? (pista.scrollLeft / fin) : 0;
      if (thumb) {
        thumb.style.setProperty('--rec-thumb-ancho', visible + '%');
        thumb.style.setProperty('--rec-thumb-left', (avance * rango) + '%');
      }
      if (prev) prev.classList.toggle('rec-inactiva', pista.scrollLeft <= 2);
      if (next) next.classList.toggle('rec-inactiva', pista.scrollLeft >= fin - 2);
    }

    function desplazar(dir) {
      var card = pista.querySelector('.rec-uc__card');
      var paso = card ? (card.offsetWidth + 16) : pista.clientWidth * 0.8;
      var cantidad = Math.max(1, Math.floor(pista.clientWidth / paso)) * paso;
      pista.scrollBy({ left: dir * cantidad, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { desplazar(-1); });
    if (next) next.addEventListener('click', function () { desplazar(1); });
    pista.addEventListener('scroll', function () { window.requestAnimationFrame(actualizar); });
    window.addEventListener('resize', actualizar);
    setTimeout(actualizar, 300);

    var progreso = raiz.querySelector('[data-rec-progreso]');
    var scrubeando = false;
    function scrubA(clientX) {
      var r = progreso.getBoundingClientRect();
      if (r.width <= 0) return;
      var ratio = (clientX - r.left) / r.width;
      ratio = Math.max(0, Math.min(1, ratio));
      pista.scrollLeft = ratio * maxScroll();
      actualizar();
    }
    if (progreso) {
      progreso.addEventListener('pointerdown', function (e) {
        scrubeando = true;
        try { progreso.setPointerCapture(e.pointerId); } catch (err) {}
        scrubA(e.clientX);
      });
      progreso.addEventListener('pointermove', function (e) { if (scrubeando) scrubA(e.clientX); });
      progreso.addEventListener('pointerup', function () { scrubeando = false; });
      progreso.addEventListener('pointercancel', function () { scrubeando = false; });
    }

    var arrastrando = false, inicioX = 0, inicioScroll = 0, movido = false;
    pista.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      arrastrando = true; movido = false;
      inicioX = e.clientX; inicioScroll = pista.scrollLeft;
      pista.classList.add('rec-arrastrando');
    });
    window.addEventListener('pointermove', function (e) {
      if (!arrastrando) return;
      var dx = e.clientX - inicioX;
      if (Math.abs(dx) > 3) movido = true;
      pista.scrollLeft = inicioScroll - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!arrastrando) return;
      arrastrando = false;
      pista.classList.remove('rec-arrastrando');
    });
    pista.addEventListener('click', function (e) {
      if (movido) { e.preventDefault(); e.stopPropagation(); movido = false; }
    }, true);

    raiz.querySelectorAll('[data-rec-card]').forEach(function (card) {
      card.addEventListener('touchstart', function () { card.classList.add('rec-segunda'); }, { passive: true });
      card.addEventListener('touchend', function () {
        setTimeout(function () { card.classList.remove('rec-segunda'); }, 1200);
      });
    });

    actualizar();
  }

  function cargar(raiz) {
    var pid = raiz.getAttribute('data-product-id');
    var sid = raiz.getAttribute('data-section-id');
    var base = raiz.getAttribute('data-url') || '/recommendations/products';
    var limite = raiz.getAttribute('data-limit') || '10';
    var intent = raiz.getAttribute('data-intent') || 'related';
    if (!pid || pid === '') { raiz.style.display = 'none'; return; }

    if (raiz.querySelector('[data-rec-pista]')) {
      iniciarCarrusel(raiz);
      return;
    }

    var url = base + '?section_id=' + encodeURIComponent(sid) + '&product_id=' + encodeURIComponent(pid) + '&intent=' + encodeURIComponent(intent) + '&limit=' + encodeURIComponent(limite);

    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresca = doc.querySelector('[data-recomendados-uc]');
        if (!fresca) { raiz.style.display = 'none'; return; }
        raiz.innerHTML = fresca.innerHTML;
        if (raiz.querySelector('[data-rec-card]')) {
          iniciarCarrusel(raiz);
        } else {
          raiz.style.display = 'none';
        }
      })
      .catch(function () { raiz.style.display = 'none'; });
  }

  document.querySelectorAll('[data-recomendados-uc]').forEach(function (raiz) {
    if (raiz.getAttribute('data-rec-listo')) return;
    raiz.setAttribute('data-rec-listo', '1');
    cargar(raiz);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["todas-colecciones"] && !Shopify.designMode) return;
  try {
    
(function () {
  function boot() {
    document.querySelectorAll('[data-cols-uc]').forEach(function (raiz) {
      var indice = raiz.querySelector('[data-cols-indice]');
      if (!indice || indice.getAttribute('data-listo') === '1') return;
      indice.setAttribute('data-listo', '1');
      indice.addEventListener('click', function (e) {
        var boton = e.target.closest ? e.target.closest('.cols-uc__letra') : null;
        if (!boton) return;
        var L = (boton.getAttribute('data-letra') || '').trim();
        indice.querySelectorAll('.cols-uc__letra').forEach(function (x) {
          x.classList.toggle('cols-uc__letra--activa', x === boton);
        });
        raiz.querySelectorAll('.cols-uc__card').forEach(function (c) {
          var cl = (c.getAttribute('data-letra') || '').trim();
          c.style.display = (L === 'TODAS' || cl === L) ? '' : 'none';
        });
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uc-cabecera-def"] && !Shopify.designMode) return;
  try {
    
(function () {
  var RETARDO_APERTURA = 110;
  var RETARDO_CIERRE = 190;
  var CLASE_BLOQUEO = 'uc-cabecera-bloqueo-scroll';

  function asegurarEstilosBloqueo() {
    if (document.getElementById('uc-cabecera-estilos-bloqueo')) return;
    var estilo = document.createElement('style');
    estilo.id = 'uc-cabecera-estilos-bloqueo';
    estilo.textContent = '.' + CLASE_BLOQUEO + ' { overflow: hidden !important; }';
    document.head.appendChild(estilo);
  }

  function iniciarCabecera(raiz) {
    if (!raiz || raiz.getAttribute('data-uc-iniciada') === 'true') return;
    raiz.setAttribute('data-uc-iniciada', 'true');
    asegurarEstilosBloqueo();

    var envoltura = raiz.closest('.uc-cabecera-seccion') || raiz.parentElement;
    var velo = raiz.querySelector('[data-uc-velo]');
    var cajon = raiz.querySelector('[data-uc-cajon]');
    var buscador = raiz.querySelector('[data-uc-buscador]');
    var campoBusqueda = raiz.querySelector('[data-uc-campo-busqueda]');
    var botonesAbrirCajon = raiz.querySelectorAll('[data-uc-abrir-cajon]');
    var botonesCerrarCajon = raiz.querySelectorAll('[data-uc-cerrar-cajon]');
    var botonesBuscador = raiz.querySelectorAll('[data-uc-abrir-buscador]');
    var botonesCerrarBuscador = raiz.querySelectorAll('[data-uc-cerrar-buscador]');
    var items = raiz.querySelectorAll('[data-uc-item]');
    var acordeones = raiz.querySelectorAll('[data-uc-acordeon]');
    var anuncios = raiz.querySelector('[data-uc-anuncios]');
    var temporizador = null;

    function medirAnuncios() {
      if (!envoltura) return;
      var altura = anuncios ? anuncios.offsetHeight : 0;
      envoltura.style.setProperty('--uc-desplazamiento', altura + 'px');
    }

    function actualizarSombra() {
      var referencia = anuncios ? anuncios.offsetHeight : 0;
      if (window.scrollY > referencia) {
        raiz.classList.add('uc-cabecera--desplazada');
      } else {
        raiz.classList.remove('uc-cabecera--desplazada');
      }
    }

    function abrirPanel(panel) {
      panel.style.setProperty('max-height', panel.scrollHeight + 'px', 'important');
    }

    function cerrarPanel(panel) {
      panel.style.setProperty('max-height', '0px', 'important');
    }

    function mostrarVelo(estado) {
      if (!velo) return;
      if (estado) {
        velo.hidden = false;
        requestAnimationFrame(function () {
          velo.classList.add('uc-cabecera__velo--visible');
        });
      } else {
        velo.classList.remove('uc-cabecera__velo--visible');
        window.setTimeout(function () {
          velo.hidden = true;
        }, 300);
      }
    }

    function abrirCajon() {
      if (!cajon) return;
      cajon.hidden = false;
      requestAnimationFrame(function () {
        cajon.classList.add('uc-cabecera__cajon--abierto');
      });
      mostrarVelo(true);
      document.documentElement.classList.add(CLASE_BLOQUEO);
      botonesAbrirCajon.forEach(function (boton) {
        boton.setAttribute('aria-expanded', 'true');
      });
    }

    function cerrarCajon() {
      if (!cajon) return;
      cajon.classList.remove('uc-cabecera__cajon--abierto');
      mostrarVelo(false);
      document.documentElement.classList.remove(CLASE_BLOQUEO);
      botonesAbrirCajon.forEach(function (boton) {
        boton.setAttribute('aria-expanded', 'false');
      });
      window.setTimeout(function () {
        if (!cajon.classList.contains('uc-cabecera__cajon--abierto')) cajon.hidden = true;
      }, 320);
    }

    function alternarBuscador(forzarCierre) {
      if (!buscador) return;
      var abierto = !buscador.hidden;
      if (abierto || forzarCierre === true) {
        buscador.hidden = true;
        botonesBuscador.forEach(function (boton) {
          boton.setAttribute('aria-expanded', 'false');
        });
      } else {
        buscador.hidden = false;
        botonesBuscador.forEach(function (boton) {
          boton.setAttribute('aria-expanded', 'true');
        });
        if (campoBusqueda) campoBusqueda.focus();
      }
    }

    function cerrarTodosLosMegas() {
      items.forEach(function (item) {
        item.classList.remove('uc-cabecera__item--abierto');
        var disparador = item.querySelector('[data-uc-disparador]');
        if (disparador) disparador.setAttribute('aria-expanded', 'false');
      });
    }

    function abrirMega(item) {
      cerrarTodosLosMegas();
      item.classList.add('uc-cabecera__item--abierto');
      var disparador = item.querySelector('[data-uc-disparador]');
      if (disparador) disparador.setAttribute('aria-expanded', 'true');
    }

    botonesAbrirCajon.forEach(function (boton) {
      boton.addEventListener('click', abrirCajon);
    });

    botonesCerrarCajon.forEach(function (boton) {
      boton.addEventListener('click', cerrarCajon);
    });

    botonesBuscador.forEach(function (boton) {
      boton.addEventListener('click', function () {
        alternarBuscador();
      });
    });

    botonesCerrarBuscador.forEach(function (boton) {
      boton.addEventListener('click', function () {
        alternarBuscador(true);
      });
    });

    if (velo) {
      velo.addEventListener('click', cerrarCajon);
    }

    items.forEach(function (item) {
      if (!item.querySelector('[data-uc-megamenu]')) return;

      item.addEventListener('mouseenter', function () {
        window.clearTimeout(temporizador);
        temporizador = window.setTimeout(function () {
          abrirMega(item);
        }, RETARDO_APERTURA);
      });

      item.addEventListener('mouseleave', function () {
        window.clearTimeout(temporizador);
        temporizador = window.setTimeout(cerrarTodosLosMegas, RETARDO_CIERRE);
      });

      item.addEventListener('focusin', function () {
        window.clearTimeout(temporizador);
        abrirMega(item);
      });

      item.addEventListener('focusout', function (evento) {
        if (!item.contains(evento.relatedTarget)) cerrarTodosLosMegas();
      });
    });

    acordeones.forEach(function (boton) {
      var panel = boton.nextElementSibling;
      if (!panel) return;

      cerrarPanel(panel);

      boton.addEventListener('click', function (evento) {
        evento.preventDefault();
        var abierto = boton.getAttribute('aria-expanded') === 'true';

        acordeones.forEach(function (otro) {
          if (otro === boton) return;
          var otroPanel = otro.nextElementSibling;
          otro.setAttribute('aria-expanded', 'false');
          if (otroPanel) cerrarPanel(otroPanel);
        });

        if (abierto) {
          boton.setAttribute('aria-expanded', 'false');
          cerrarPanel(panel);
        } else {
          boton.setAttribute('aria-expanded', 'true');
          abrirPanel(panel);
        }
      });
    });

    document.addEventListener('keydown', function (evento) {
      if (evento.key !== 'Escape') return;
      cerrarTodosLosMegas();
      alternarBuscador(true);
      if (cajon && cajon.classList.contains('uc-cabecera__cajon--abierto')) cerrarCajon();
    });

    window.addEventListener('scroll', actualizarSombra, { passive: true });

    window.addEventListener('resize', function () {
      medirAnuncios();
      acordeones.forEach(function (boton) {
        if (boton.getAttribute('aria-expanded') !== 'true') return;
        var panel = boton.nextElementSibling;
        if (panel) abrirPanel(panel);
      });
    });

    medirAnuncios();
    actualizarSombra();
    window.setTimeout(medirAnuncios, 400);

    if (anuncios) {
      var mensajes = anuncios.querySelectorAll('[data-uc-anuncio]');
      if (mensajes.length > 1) {
        var actual = 0;
        var velocidad = parseInt(anuncios.getAttribute('data-velocidad'), 10) || 4;
        window.setInterval(function () {
          mensajes[actual].classList.remove('uc-cabecera__anuncio--activo');
          actual = (actual + 1) % mensajes.length;
          mensajes[actual].classList.add('uc-cabecera__anuncio--activo');
        }, velocidad * 1000);
      }
    }
  }

  function iniciarTodas(contexto) {
    var ambito = contexto || document;
    var cabeceras = ambito.querySelectorAll('[data-uc-cabecera]');
    Array.prototype.forEach.call(cabeceras, iniciarCabecera);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      iniciarTodas();
    });
  } else {
    iniciarTodas();
  }

  document.addEventListener('shopify:section:load', function (evento) {
    iniciarTodas(evento.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uc-carrupsel-pro-def"] && !Shopify.designMode) return;
  try {
    
(function () {
  var CLAVE_VISTOS = 'uc-vistos';

  function separarMiles(entero, separador) {
    return entero.replace(/\B(?=(\d{3})+(?!\d))/g, separador);
  }

  function formatearDinero(centavos, formato) {
    var valor = (centavos / 100).toFixed(2);
    var partes = valor.split('.');
    var entero = partes[0];
    var decimales = partes[1];

    return formato.replace(/\{\{\s*(\w+)\s*\}\}/, function (coincidencia, nombre) {
      if (nombre === 'amount_no_decimals') {
        return separarMiles(entero, ',');
      }
      if (nombre === 'amount_with_comma_separator') {
        return separarMiles(entero, '.') + ',' + decimales;
      }
      if (nombre === 'amount_no_decimals_with_comma_separator') {
        return separarMiles(entero, '.');
      }
      if (nombre === 'amount_with_apostrophe_separator') {
        return separarMiles(entero, "'") + '.' + decimales;
      }
      return separarMiles(entero, ',') + '.' + decimales;
    });
  }

  function leerVistos() {
    try {
      return JSON.parse(window.localStorage.getItem(CLAVE_VISTOS) || '[]');
    } catch (error) {
      return [];
    }
  }

  function registrarVisto(handle) {
    if (!handle) return;
    try {
      var guardados = leerVistos().filter(function (item) {
        return item !== handle;
      });
      guardados.unshift(handle);
      window.localStorage.setItem(CLAVE_VISTOS, JSON.stringify(guardados.slice(0, 20)));
    } catch (error) {
      return;
    }
  }

  function crearTarjeta(datos, opciones) {
    var enlace = document.createElement('a');
    enlace.className = 'uc-carrusel__tarjeta';
    enlace.setAttribute('data-uc-tarjeta', '');
    enlace.href = opciones.raiz + 'products/' + datos.handle;

    var caja = document.createElement('div');
    caja.className = 'uc-carrusel__imagen';

    if (datos.featured_image) {
      var imagen = document.createElement('img');
      imagen.src = datos.featured_image.replace(/(\.[a-zA-Z]+)(\?|$)/, '_700x$1$2');
      imagen.alt = datos.title;
      imagen.loading = 'lazy';
      caja.appendChild(imagen);
    }

    if (opciones.mostrarEtiqueta && opciones.etiqueta) {
      var etiqueta = document.createElement('span');
      etiqueta.className = 'uc-carrusel__etiqueta';
      etiqueta.textContent = opciones.etiqueta;
      caja.appendChild(etiqueta);
    }

    enlace.appendChild(caja);

    if (opciones.mostrarMarca && datos.vendor) {
      var marca = document.createElement('span');
      marca.className = 'uc-carrusel__marca';
      marca.textContent = datos.vendor;
      enlace.appendChild(marca);
    }

    var nombre = document.createElement('span');
    nombre.className = 'uc-carrusel__nombre';
    nombre.textContent = datos.title;
    enlace.appendChild(nombre);

    var precios = document.createElement('span');
    precios.className = 'uc-carrusel__precios';

    var precio = document.createElement('span');
    precio.className = 'uc-carrusel__precio';
    precio.textContent = formatearDinero(datos.price, opciones.formato);
    precios.appendChild(precio);

    if (datos.compare_at_price && datos.compare_at_price > datos.price) {
      var antes = document.createElement('span');
      antes.className = 'uc-carrusel__precio-antes';
      antes.textContent = formatearDinero(datos.compare_at_price, opciones.formato);
      precios.appendChild(antes);
    }

    enlace.appendChild(precios);
    return enlace;
  }

  function cargarVistos(raiz, pista, vacio) {
    var handleActual = raiz.getAttribute('data-handle-actual');
    var limite = parseInt(raiz.getAttribute('data-limite'), 10) || 8;
    var raizUrl = raiz.getAttribute('data-raiz-url') || '/';
    if (raizUrl.charAt(raizUrl.length - 1) !== '/') raizUrl = raizUrl + '/';

    var opciones = {
      raiz: raizUrl,
      formato: raiz.getAttribute('data-formato') || '${{amount_with_comma_separator}}',
      etiqueta: raiz.getAttribute('data-etiqueta'),
      mostrarEtiqueta: raiz.getAttribute('data-mostrar-etiqueta') === 'true',
      mostrarMarca: raiz.getAttribute('data-mostrar-marca') === 'true'
    };

    var handles = leerVistos().filter(function (handle) {
      return handle && handle !== handleActual;
    }).slice(0, limite);

    if (!handles.length) {
      raiz.classList.add('uc-carrusel--vacia');
      if (vacio) vacio.hidden = false;
      return;
    }

    var peticiones = handles.map(function (handle) {
      return fetch(raizUrl + 'products/' + handle + '.js')
        .then(function (respuesta) {
          if (!respuesta.ok) throw new Error('sin producto');
          return respuesta.json();
        })
        .catch(function () {
          return null;
        });
    });

    Promise.all(peticiones).then(function (resultados) {
      var validos = resultados.filter(function (item) {
        return item && item.available !== false;
      });

      if (!validos.length) {
        raiz.classList.add('uc-carrusel--vacia');
        if (vacio) vacio.hidden = false;
        return;
      }

      validos.forEach(function (datos) {
        pista.appendChild(crearTarjeta(datos, opciones));
      });
    });
  }

  function iniciarCarrusel(raiz) {
    if (!raiz || raiz.getAttribute('data-uc-iniciado') === 'true') return;
    raiz.setAttribute('data-uc-iniciado', 'true');

    registrarVisto(raiz.getAttribute('data-handle-actual'));

    var pista = raiz.querySelector('[data-uc-pista]');
    var vacio = raiz.querySelector('[data-uc-vacio]');
    var anterior = raiz.querySelector('[data-uc-anterior]');
    var siguiente = raiz.querySelector('[data-uc-siguiente]');
    if (!pista) return;

    if (raiz.getAttribute('data-origen') === 'vistos') {
      cargarVistos(raiz, pista, vacio);
    } else if (!pista.querySelector('[data-uc-tarjeta]')) {
      raiz.classList.add('uc-carrusel--vacia');
    }

    function paso() {
      var tarjeta = pista.querySelector('[data-uc-tarjeta]');
      if (!tarjeta) return pista.clientWidth;
      return tarjeta.getBoundingClientRect().width + 16;
    }

    if (anterior) {
      anterior.addEventListener('click', function () {
        pista.scrollBy({ left: -paso(), behavior: 'smooth' });
      });
    }

    if (siguiente) {
      siguiente.addEventListener('click', function () {
        pista.scrollBy({ left: paso(), behavior: 'smooth' });
      });
    }
  }

  function iniciarTodos(contexto) {
    var ambito = contexto || document;
    var nodos = ambito.querySelectorAll('[data-uc-carrusel]');
    Array.prototype.forEach.call(nodos, iniciarCarrusel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      iniciarTodos();
    });
  } else {
    iniciarTodos();
  }

  document.addEventListener('shopify:section:load', function (evento) {
    iniciarTodos(evento.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uc-colecciones-filtros"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(raiz) {
    var form = raiz.querySelector('[data-coluc-form]');
    var panel = raiz.querySelector('[data-coluc-panel]');
    var overlay = raiz.querySelector('[data-coluc-overlay]');
    var abrir = raiz.querySelector('[data-coluc-abrir]');
    var cerrar = raiz.querySelector('[data-coluc-cerrar]');
    if (!form) return;

    function esEscritorio() {
      return window.matchMedia('(min-width: 990px)').matches;
    }

    function abrirPanel() {
      if (panel) panel.classList.add('coluc-activo');
      if (overlay) overlay.classList.add('coluc-activo');
      document.body.style.overflow = 'hidden';
    }
    function cerrarPanel() {
      if (panel) panel.classList.remove('coluc-activo');
      if (overlay) overlay.classList.remove('coluc-activo');
      document.body.style.overflow = '';
    }
    if (abrir) abrir.addEventListener('click', abrirPanel);
    if (cerrar) cerrar.addEventListener('click', cerrarPanel);
    if (overlay) overlay.addEventListener('click', cerrarPanel);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') cerrarPanel();
    });

    var sort = raiz.querySelector('[data-coluc-sort]');
    if (sort) {
      sort.addEventListener('change', function () { form.submit(); });
    }

    raiz.querySelectorAll('[data-coluc-check]').forEach(function (chk) {
      chk.addEventListener('change', function () {
        if (esEscritorio()) form.submit();
      });
    });

    raiz.querySelectorAll('[data-coluc-precio]').forEach(function (inp) {
      inp.addEventListener('change', function () {
        if (esEscritorio()) form.submit();
      });
    });

    raiz.querySelectorAll('[data-coluc-vermas]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var cont = btn.closest('[data-coluc-opciones]');
        if (cont) cont.classList.add('coluc-todos');
      });
    });
  }

  document.querySelectorAll('[data-coluc]').forEach(function (raiz) {
    if (raiz.getAttribute('data-coluc-listo')) return;
    raiz.setAttribute('data-coluc-listo', '1');
    iniciar(raiz);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uc-explorar-modelos"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(raiz) {
    var track = raiz.querySelector('[data-modelo-pills]');
    if (!track) return;
    var prev = raiz.querySelector('[data-modelo-prev]');
    var next = raiz.querySelector('[data-modelo-next]');

    function paso() {
      return Math.max(220, track.clientWidth * 0.7);
    }
    function actualizar() {
      if (!prev || !next) return;
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -paso(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: paso(), behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(actualizar); }, { passive: true });
    window.addEventListener('resize', actualizar);
    actualizar();
  }

  document.querySelectorAll('[data-modelo-uc]').forEach(function (raiz) {
    if (raiz.getAttribute('data-modelo-listo')) return;
    raiz.setAttribute('data-modelo-listo', '1');
    iniciar(raiz);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uc-mas-vendidos"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(raiz) {
    var track = raiz.querySelector('[data-nu-track]');
    if (!track) return;
    var prev = raiz.querySelector('[data-nu-prev]');
    var next = raiz.querySelector('[data-nu-next]');

    function paso() {
      var card = track.querySelector('.nuevos-uc__card');
      if (!card) return track.clientWidth;
      var gap = parseInt(getComputedStyle(track).columnGap, 10) || 16;
      var ancho = card.getBoundingClientRect().width + gap;
      var visibles = Math.max(1, Math.floor(track.clientWidth / ancho));
      return ancho * visibles;
    }

    function actualizar() {
      if (!prev || !next) return;
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -paso(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: paso(), behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(actualizar); }, { passive: true });
    window.addEventListener('resize', actualizar);
    actualizar();
  }

  document.querySelectorAll('[data-nuevos-uc]').forEach(function (raiz) {
    if (raiz.getAttribute('data-nu-listo')) return;
    raiz.setAttribute('data-nu-listo', '1');
    iniciar(raiz);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uc-pag-mas-vendidos"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciarVendidos(raiz) {
    if (!raiz || raiz.getAttribute('data-uc-iniciado') === 'true') return;
    raiz.setAttribute('data-uc-iniciado', 'true');

    var lista = raiz.querySelector('[data-uc-lista]');
    var anterior = raiz.querySelector('[data-uc-anterior]');
    var siguiente = raiz.querySelector('[data-uc-siguiente]');
    if (!lista) return;

    function esCarrusel() {
      return window.getComputedStyle(lista).overflowX !== 'visible';
    }

    function paso() {
      var tarjeta = lista.querySelector('[data-uc-tarjeta]');
      if (!tarjeta) return lista.clientWidth;
      var estilo = window.getComputedStyle(lista);
      var separacion = parseFloat(estilo.columnGap || estilo.gap) || 0;
      return tarjeta.getBoundingClientRect().width + separacion;
    }

    function mover(direccion) {
      if (esCarrusel()) {
        lista.scrollBy({ left: direccion * paso(), behavior: 'smooth' });
        return;
      }
      var destino = direccion > 0 ? lista.scrollHeight : 0;
      lista.scrollTo({ top: destino, behavior: 'smooth' });
    }

    function actualizarFlechas() {
      if (!anterior || !siguiente) return;
      if (!esCarrusel()) {
        anterior.hidden = true;
        siguiente.hidden = true;
        return;
      }
      anterior.hidden = false;
      siguiente.hidden = false;
      anterior.disabled = lista.scrollLeft <= 2;
      siguiente.disabled = lista.scrollLeft + lista.clientWidth >= lista.scrollWidth - 2;
    }

    if (anterior) {
      anterior.addEventListener('click', function () {
        mover(-1);
      });
    }

    if (siguiente) {
      siguiente.addEventListener('click', function () {
        mover(1);
      });
    }

    lista.addEventListener('scroll', actualizarFlechas, { passive: true });
    window.addEventListener('resize', actualizarFlechas);
    actualizarFlechas();
  }

  function iniciarTodas(contexto) {
    var ambito = contexto || document;
    var nodos = ambito.querySelectorAll('[data-uc-vendidos]');
    Array.prototype.forEach.call(nodos, iniciarVendidos);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      iniciarTodas();
    });
  } else {
    iniciarTodas();
  }

  document.addEventListener('shopify:section:load', function (evento) {
    iniciarTodas(evento.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uc-producto-def"] && !Shopify.designMode) return;
  try {
    
(function () {
  var MESES = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
  var CLAVE_VISTOS = 'uc-vistos';

  function sumarDiasHabiles(fecha, dias) {
    var resultado = new Date(fecha.getTime());
    var restantes = dias;
    while (restantes > 0) {
      resultado.setDate(resultado.getDate() + 1);
      var dia = resultado.getDay();
      if (dia !== 0 && dia !== 6) restantes--;
    }
    return resultado;
  }

  function formatearFecha(fecha) {
    return fecha.getDate() + ' ' + MESES[fecha.getMonth()];
  }

  function registrarVisto(handle) {
    if (!handle) return;
    try {
      var guardados = JSON.parse(window.localStorage.getItem(CLAVE_VISTOS) || '[]');
      guardados = guardados.filter(function (item) {
        return item !== handle;
      });
      guardados.unshift(handle);
      window.localStorage.setItem(CLAVE_VISTOS, JSON.stringify(guardados.slice(0, 20)));
    } catch (error) {
      return;
    }
  }

  function iniciarProducto(raiz) {
    if (!raiz || raiz.getAttribute('data-uc-iniciado') === 'true') return;
    raiz.setAttribute('data-uc-iniciado', 'true');

    registrarVisto(raiz.getAttribute('data-handle'));

    var datos = raiz.querySelector('[data-uc-variantes]');
    var variantes = [];
    if (datos) {
      try {
        variantes = JSON.parse(datos.textContent);
      } catch (error) {
        variantes = [];
      }
    }

    var formulario = raiz.querySelector('form');
    var galeria = raiz.querySelector('[data-uc-galeria]');
    var slides = raiz.querySelectorAll('[data-uc-slide]');
    var miniaturas = raiz.querySelectorAll('[data-uc-miniatura]');
    var contador = raiz.querySelector('[data-uc-contador-actual]');
    var radios = raiz.querySelectorAll('[data-uc-radio]');
    var etiquetasValor = raiz.querySelectorAll('[data-uc-valor-elegido]');
    var zonaSelector = raiz.querySelector('[data-uc-zona-selector]');
    var campoId = raiz.querySelector('[data-uc-id-variante]');
    var precios = raiz.querySelectorAll('[data-uc-precio]');
    var precioAntes = raiz.querySelector('[data-uc-precio-antes]');
    var descuento = raiz.querySelector('[data-uc-descuento]');
    var descuentoValor = raiz.querySelector('[data-uc-descuento-valor]');
    var botonAgregar = raiz.querySelector('[data-uc-boton-agregar]');
    var textoBoton = raiz.querySelector('[data-uc-texto-boton]');
    var botonAhora = raiz.querySelector('[data-uc-comprar-ahora]');
    var textoAhora = raiz.querySelector('[data-uc-texto-ahora]');
    var acordeones = raiz.querySelectorAll('[data-uc-acordeon]');
    var barra = raiz.querySelector('[data-uc-barra]');
    var botonBarra = raiz.querySelector('[data-uc-barra-comprar]');
    var textoBarra = raiz.querySelector('[data-uc-texto-barra]');
    var selectTalla = raiz.querySelector('[data-uc-select-talla]');
    var modalGuia = raiz.querySelector('[data-uc-modal-guia]');
    var abrirGuia = raiz.querySelectorAll('[data-uc-abrir-guia]');
    var cerrarGuia = raiz.querySelectorAll('[data-uc-cerrar-guia]');
    var visor = raiz.querySelector('[data-uc-visor]');
    var visorImagen = raiz.querySelector('[data-uc-visor-imagen]');
    var aperturasZoom = raiz.querySelectorAll('[data-uc-abrir-zoom]');
    var cantidadBotones = raiz.querySelectorAll('[data-uc-cantidad]');
    var campoCantidad = raiz.querySelector('[data-uc-campo-cantidad]');
    var entrega = raiz.querySelector('[data-uc-entrega]');
    var indiceVisor = 0;
    var indiceGaleria = 0;

    function hayOpciones() {
      return radios.length > 0;
    }

    function leerSeleccion() {
      var elegidos = [];
      radios.forEach(function (radio) {
        if (!radio.checked) return;
        elegidos[parseInt(radio.getAttribute('data-indice'), 10)] = radio.value;
      });
      return elegidos;
    }

    function seleccionCompleta() {
      if (!hayOpciones()) return true;
      var total = 0;
      radios.forEach(function (radio) {
        var indice = parseInt(radio.getAttribute('data-indice'), 10);
        if (indice + 1 > total) total = indice + 1;
      });
      var elegidos = leerSeleccion();
      for (var i = 0; i < total; i++) {
        if (!elegidos[i]) return false;
      }
      return true;
    }

    function buscarVariante(seleccion) {
      for (var i = 0; i < variantes.length; i++) {
        var coincide = true;
        for (var j = 0; j < seleccion.length; j++) {
          if (variantes[i].opciones[j] !== seleccion[j]) {
            coincide = false;
            break;
          }
        }
        if (coincide) return variantes[i];
      }
      return null;
    }

    function marcarDisponibilidad(seleccion) {
      radios.forEach(function (radio) {
        var indice = parseInt(radio.getAttribute('data-indice'), 10);
        var prueba = seleccion.slice();
        prueba[indice] = radio.value;
        var disponible = false;
        for (var i = 0; i < variantes.length; i++) {
          var coincide = true;
          for (var j = 0; j < prueba.length; j++) {
            if (j !== indice && prueba[j] === undefined) continue;
            if (variantes[i].opciones[j] !== prueba[j]) {
              coincide = false;
              break;
            }
          }
          if (coincide && variantes[i].disponible) {
            disponible = true;
            break;
          }
        }
        var etiqueta = radio.closest('.uc-producto__valor');
        if (!etiqueta) return;
        if (disponible) {
          etiqueta.classList.remove('uc-producto__valor--agotado');
        } else {
          etiqueta.classList.add('uc-producto__valor--agotado');
        }
      });
    }

    function marcarMiniatura(indice) {
      miniaturas.forEach(function (miniatura, posicion) {
        if (posicion === indice) {
          miniatura.classList.add('uc-producto__miniatura--activa');
        } else {
          miniatura.classList.remove('uc-producto__miniatura--activa');
        }
      });
    }

    function irASlide(indice) {
      if (!galeria || !slides[indice]) return;
      galeria.scrollTo({ left: slides[indice].offsetLeft, behavior: 'smooth' });
      indiceGaleria = indice;
      if (contador) contador.textContent = indice + 1;
      marcarMiniatura(indice);
    }

    function pedirTalla() {
      if (!zonaSelector) return;
      zonaSelector.scrollIntoView({ behavior: 'smooth', block: 'center' });
      zonaSelector.classList.add('uc-producto__bloque--aviso');
      window.setTimeout(function () {
        zonaSelector.classList.remove('uc-producto__bloque--aviso');
      }, 700);
    }

    function actualizarVariante() {
      var seleccion = leerSeleccion();
      var completa = seleccionCompleta();
      var variante = completa ? buscarVariante(seleccion) : null;

      marcarDisponibilidad(seleccion);

      etiquetasValor.forEach(function (etiqueta) {
        var indice = parseInt(etiqueta.getAttribute('data-indice'), 10);
        etiqueta.textContent = seleccion[indice] || '';
      });

      if (selectTalla && seleccion[0]) selectTalla.value = seleccion[0];

      var etiquetaBoton = '';
      if (!completa) {
        etiquetaBoton = botonAgregar ? botonAgregar.getAttribute('data-texto-sin-talla') : '';
      } else if (variante && variante.disponible) {
        etiquetaBoton = botonAgregar ? botonAgregar.getAttribute('data-texto-disponible') : '';
      } else {
        etiquetaBoton = botonAgregar ? botonAgregar.getAttribute('data-texto-agotado') : '';
      }

      if (textoBoton && etiquetaBoton) textoBoton.textContent = etiquetaBoton;
      if (textoBarra && etiquetaBoton) textoBarra.textContent = etiquetaBoton;

      if (botonAgregar) botonAgregar.disabled = completa && (!variante || !variante.disponible);
      if (botonAhora) botonAhora.disabled = completa && (!variante || !variante.disponible);
      if (botonBarra) botonBarra.disabled = completa && (!variante || !variante.disponible);

      if (!variante) return;

      if (campoId) campoId.value = variante.id;

      precios.forEach(function (nodo) {
        nodo.textContent = variante.precio;
      });

      if (precioAntes) {
        if (variante.antes) {
          precioAntes.textContent = variante.antes;
          precioAntes.classList.remove('uc-producto__precio-antes--oculto');
        } else {
          precioAntes.classList.add('uc-producto__precio-antes--oculto');
        }
      }

      if (descuento) {
        if (variante.descuento > 0) {
          if (descuentoValor) descuentoValor.textContent = variante.descuento;
          descuento.classList.remove('uc-producto__descuento--oculto');
        } else {
          descuento.classList.add('uc-producto__descuento--oculto');
        }
      }

      if (variante.media) {
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].getAttribute('data-media-id') === String(variante.media)) {
            irASlide(i);
            break;
          }
        }
      }

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variante.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', actualizarVariante);
    });

    if (selectTalla) {
      selectTalla.addEventListener('change', function () {
        var valor = selectTalla.value;
        if (!valor) return;
        radios.forEach(function (radio) {
          if (parseInt(radio.getAttribute('data-indice'), 10) !== 0) return;
          if (radio.value === valor) radio.checked = true;
        });
        actualizarVariante();
      });
    }

    if (botonAgregar) {
      botonAgregar.addEventListener('click', function (evento) {
        if (seleccionCompleta()) return;
        evento.preventDefault();
        pedirTalla();
      });
    }

    if (botonBarra) {
      botonBarra.addEventListener('click', function () {
        if (!seleccionCompleta()) {
          pedirTalla();
          return;
        }
        if (botonAgregar) botonAgregar.click();
      });
    }

    if (botonAhora && formulario) {
      botonAhora.addEventListener('click', function () {
        if (!seleccionCompleta()) {
          pedirTalla();
          return;
        }
        var cargando = botonAhora.getAttribute('data-texto-cargando');
        var original = textoAhora ? textoAhora.textContent : '';
        botonAhora.disabled = true;
        if (textoAhora && cargando) textoAhora.textContent = cargando;

        var destino = raiz.getAttribute('data-url-agregar') || '/cart/add';
        fetch(destino + '.js', {
          method: 'POST',
          body: new FormData(formulario),
          headers: { Accept: 'application/json' }
        })
          .then(function (respuesta) {
            if (!respuesta.ok) throw new Error('error');
            return respuesta.json();
          })
          .then(function () {
            window.location.href = '/checkout';
          })
          .catch(function () {
            botonAhora.disabled = false;
            if (textoAhora) textoAhora.textContent = original;
            formulario.submit();
          });
      });
    }

    if (galeria) {
      galeria.addEventListener('scroll', function () {
        if (!galeria.clientWidth) return;
        var indice = Math.round(galeria.scrollLeft / galeria.clientWidth);
        if (indice === indiceGaleria) return;
        indiceGaleria = indice;
        if (contador) contador.textContent = indice + 1;
        marcarMiniatura(indice);
      }, { passive: true });
    }

    miniaturas.forEach(function (miniatura) {
      miniatura.addEventListener('click', function () {
        irASlide(parseInt(miniatura.getAttribute('data-indice'), 10));
      });
    });

    var flechaAnterior = raiz.querySelector('[data-uc-galeria-anterior]');
    if (flechaAnterior) {
      flechaAnterior.addEventListener('click', function () {
        irASlide((indiceGaleria - 1 + slides.length) % slides.length);
      });
    }

    var flechaSiguiente = raiz.querySelector('[data-uc-galeria-siguiente]');
    if (flechaSiguiente) {
      flechaSiguiente.addEventListener('click', function () {
        irASlide((indiceGaleria + 1) % slides.length);
      });
    }

    acordeones.forEach(function (boton) {
      var panel = boton.nextElementSibling;
      if (!panel) return;
      panel.style.setProperty('max-height', '0px', 'important');

      boton.addEventListener('click', function () {
        var abierto = boton.getAttribute('aria-expanded') === 'true';
        if (abierto) {
          boton.setAttribute('aria-expanded', 'false');
          panel.style.setProperty('max-height', '0px', 'important');
        } else {
          boton.setAttribute('aria-expanded', 'true');
          panel.style.setProperty('max-height', panel.scrollHeight + 'px', 'important');
        }
      });
    });

    cantidadBotones.forEach(function (boton) {
      boton.addEventListener('click', function () {
        if (!campoCantidad) return;
        var paso = parseInt(boton.getAttribute('data-uc-cantidad'), 10);
        var valor = parseInt(campoCantidad.value, 10) || 1;
        campoCantidad.value = Math.max(1, valor + paso);
      });
    });

    if (barra && botonAgregar && 'IntersectionObserver' in window) {
      var observador = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (entrada) {
          if (entrada.isIntersecting) {
            barra.classList.remove('uc-producto__barra--visible');
          } else {
            barra.classList.add('uc-producto__barra--visible');
          }
        });
      }, { threshold: 0 });
      observador.observe(botonAgregar);
    }

    abrirGuia.forEach(function (boton) {
      boton.addEventListener('click', function () {
        if (modalGuia) modalGuia.hidden = false;
      });
    });

    cerrarGuia.forEach(function (boton) {
      boton.addEventListener('click', function () {
        if (modalGuia) modalGuia.hidden = true;
      });
    });

    function mostrarVisor(indice) {
      if (!visor || !visorImagen || !aperturasZoom[indice]) return;
      indiceVisor = indice;
      visorImagen.src = aperturasZoom[indice].getAttribute('data-grande');
      visor.hidden = false;
    }

    aperturasZoom.forEach(function (boton) {
      boton.addEventListener('click', function () {
        mostrarVisor(parseInt(boton.getAttribute('data-indice'), 10));
      });
    });

    var cerrarVisor = raiz.querySelector('[data-uc-cerrar-visor]');
    if (cerrarVisor) {
      cerrarVisor.addEventListener('click', function () {
        if (visor) visor.hidden = true;
      });
    }

    var anterior = raiz.querySelector('[data-uc-visor-anterior]');
    if (anterior) {
      anterior.addEventListener('click', function () {
        mostrarVisor((indiceVisor - 1 + aperturasZoom.length) % aperturasZoom.length);
      });
    }

    var siguiente = raiz.querySelector('[data-uc-visor-siguiente]');
    if (siguiente) {
      siguiente.addEventListener('click', function () {
        mostrarVisor((indiceVisor + 1) % aperturasZoom.length);
      });
    }

    document.addEventListener('keydown', function (evento) {
      if (evento.key === 'Escape') {
        if (visor) visor.hidden = true;
        if (modalGuia) modalGuia.hidden = true;
        return;
      }
      if (!visor || visor.hidden) return;
      if (evento.key === 'ArrowLeft') {
        mostrarVisor((indiceVisor - 1 + aperturasZoom.length) % aperturasZoom.length);
      }
      if (evento.key === 'ArrowRight') {
        mostrarVisor((indiceVisor + 1) % aperturasZoom.length);
      }
    });

    if (entrega) {
      var hoy = new Date();
      var proceso = parseInt(entrega.getAttribute('data-dias-proceso'), 10) || 1;
      var minimo = parseInt(entrega.getAttribute('data-dias-min'), 10) || 4;
      var maximo = parseInt(entrega.getAttribute('data-dias-max'), 10) || 10;

      var finProceso = sumarDiasHabiles(hoy, proceso);
      var inicioEntrega = sumarDiasHabiles(hoy, minimo);
      var finEntrega = sumarDiasHabiles(hoy, maximo);

      var nodoCompra = entrega.querySelector('[data-uc-paso-compra]');
      var nodoProceso = entrega.querySelector('[data-uc-paso-proceso]');
      var nodoEntrega = entrega.querySelector('[data-uc-paso-entrega]');
      var nodoMin = entrega.querySelector('[data-uc-fecha-min]');
      var nodoMax = entrega.querySelector('[data-uc-fecha-max]');

      if (nodoCompra) nodoCompra.textContent = formatearFecha(hoy);
      if (nodoProceso) {
        nodoProceso.textContent = formatearFecha(sumarDiasHabiles(hoy, 1)) + ' - ' + formatearFecha(finProceso);
      }
      if (nodoEntrega) {
        nodoEntrega.textContent = formatearFecha(inicioEntrega) + ' - ' + formatearFecha(finEntrega);
      }
      if (nodoMin) nodoMin.textContent = formatearFecha(inicioEntrega);
      if (nodoMax) nodoMax.textContent = formatearFecha(finEntrega);
    }

    actualizarVariante();
  }

  function iniciarTodos(contexto) {
    var ambito = contexto || document;
    var nodos = ambito.querySelectorAll('[data-uc-producto]');
    Array.prototype.forEach.call(nodos, iniciarProducto);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      iniciarTodos();
    });
  } else {
    iniciarTodos();
  }

  document.addEventListener('shopify:section:load', function (evento) {
    iniciarTodos(evento.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ultimos-drops-uc"] && !Shopify.designMode) return;
  try {
    
(function () {
  var raiz = document.querySelector('[data-drops-uc]');
  if (!raiz) return;

  function activar(modo, idx) {
    raiz.querySelectorAll('[data-stack]').forEach(function (st) {
      var on = st.getAttribute('data-stack') === modo;
      st.querySelectorAll('[data-shot]').forEach(function (sh) {
        sh.classList.toggle('drops-uc__shot--activo', on && sh.getAttribute('data-shot') === String(idx));
      });
    });
    raiz.querySelectorAll('[data-lista]').forEach(function (l) {
      var on = l.getAttribute('data-lista') === modo;
      l.querySelectorAll('[data-row]').forEach(function (r) {
        r.classList.toggle('drops-uc__row--activo', on && r.getAttribute('data-row') === String(idx));
      });
    });
  }

  function setModo(modo) {
    raiz.setAttribute('data-modo', modo);
    raiz.querySelectorAll('[data-modo-btn]').forEach(function (b) {
      b.classList.toggle('drops-uc__tg--activo', b.getAttribute('data-modo-btn') === modo);
    });
    activar(modo, 0);
  }

  raiz.querySelectorAll('[data-modo-btn]').forEach(function (b) {
    b.addEventListener('click', function () { setModo(b.getAttribute('data-modo-btn')); });
  });

  raiz.querySelectorAll('[data-lista]').forEach(function (l) {
    var modo = l.getAttribute('data-lista');
    l.querySelectorAll('[data-row]').forEach(function (r) {
      r.addEventListener('mouseenter', function () { activar(modo, r.getAttribute('data-row')); });
    });
    l.addEventListener('mouseleave', function () { activar(modo, 0); });
  });

  setModo(raiz.getAttribute('data-modo') || 'drops');
})();

  } catch(e) { console.error(e); }
})();
})();
